jQuery(document).ready(function($){


    


    // Was: Klaviyo form WyQTy8. Now the OneFit product-finder popup, which is
    // rendered on this page with data-manual-trigger (so it never self-opens).
    // autoOpen() honours the "completed" / "dismissed in the last 5 days" limits.
    setTimeout(function () {

        if ($('body').is('.quiz-enabled, .pathway-info-opened')) return;
        if (window.FonQuiz && typeof window.FonQuiz.autoOpen === 'function') {
            window.FonQuiz.autoOpen();
        }

    }, 8000);

    

    const orderFromValue = $('[data-order-from]').data('order-from');
    console.log('orderFromValue',orderFromValue);

    // ─── Quiz State ───────────────────────────────────────────────────────────────
    var quizSelections = {
        name: '',
        goal: '',
        exercise: '',
        nmn: '',
        'current-supplement': [],
        statis: 'pending',
        matter: '',
        onelife_added: false  // tracks if user clicked "Add OneLife" vs "Pass"
    };

    new Swiper('.swiper-index-2026-ups', {
        slidesPerView: 1.10,
        spaceBetween: 21,
        autoHeight: false,
        loop: window.innerWidth < 768, // Disabled on desktop

        autoplay: {
        delay: 3000,
        disableOnInteraction: false,  // keeps playing after swipe
        pauseOnMouseEnter: false,      // keeps playing on hover
        },

        breakpoints: {
        768: {
            slidesPerView: 4.2
        }
        }
    });


    // // Open directly via API
    // $.magnificPopup.open({
    //     items: {
    //         src: '#unicorn-comprehensive-ingredients', // can be a HTML string, jQuery object, or CSS selector
    //         type: 'inline'
    //     }
    // });


    // Ingredients Popup
    $(document).on('click','.btn-whats-inside',function(){
        
        var popup = $(this).attr('data-popup');
        var plan = $(this).parents('.unicorn-buy-product-panel').find('.product-buy-plan .active').data('plan');

        $(`.white-popup[data-popup="${popup}"]`).attr('data-plan',plan);

        $('.popup-ingredients-container[data-popup="inside"]').addClass('active');
        $('.popup-ingredients-container[data-popup="replace"]').removeClass('active');


        $.magnificPopup.open({
            mainClass: 'mfp-fade-blur',
            items: {
                src: `.white-popup[data-popup="${popup}"]`,
                type: 'inline'
            }
        });


    });
    // $(document).on('click','.popup-action button',function(){
        
    //     var popup = $(this).data('popup');

    //     $(this).parents('.popup-ingredients-container').removeClass('active');
    //     $(`.popup-ingredients-container[data-popup="${popup}"]`).addClass('active');
    // });


    $(document).on('click', '.popup-action button', function() {
        var popup = $(this).data('popup');
        var $current = $(this).parents('.popup-ingredients-container');
        var $next = $(`.popup-ingredients-container[data-popup="${popup}"]`);

        if ($current.is($next)) return;

        $current.fadeOut(300, function() {
            $next.fadeIn(300);
        });
    });

    // Panel Selector
    $(document).on('click','.buy-options-main .btn-continue-to-plan',function(){

        var parent = $(this).parents('.option-info');
        var option = $('.buy-options-main .option.active');
        const product = option.data('product');

        option.siblings().removeClass('active');
        $('pathway-popup').removeClass('active');
        option.addClass('active');

        

        $('html, body').animate({
            scrollTop: $('#get-started').offset().top - 120
        }, 1300); // 600ms smooth scroll

        setTimeout(() => {

            
            $('.unicorn-buy-panel[data-panel="main"]').fadeOut(300).removeClass('active');

            $('.sticky-unicorn-selector').addClass('active');
            $(`.unicorn-buy-panel[data-panel="${product}"]`).fadeIn(300).addClass('active');

            $(`.unicorn-buy-panel[data-panel="${product}"] .product-buy-plan div`).first().trigger('click');

            $('body').addClass('body-stick-unicorn-selector');

            

        }, 500);

    });

    $(document).on('click','.other-path',function(){
        const product = $(this).data('path');
        $('.pathway-popup[data-product="'+product+'"]').addClass('active').siblings().removeClass('active');

        $('.continue-with-plan-wrapper').removeAttr('data-parent-fade-out-animating');
        setTimeout(function(){
            $('.continue-with-plan-wrapper').attr('data-parent-fade-out-animating', '');
        },500);

        $('.pathway-popup.active').animate({ scrollTop: 0 }, 600);

    });

    // apply each element's delay (attribute value in ms)
    $('[data-fade-out-delay]').each(function () {
        $(this).css('transition-delay', (parseInt($(this).data('fade-out-delay'), 10) || 0) + 'ms');
    });


    $(document).on('click','.buy-options .option',function(){
        
        const product = $(this).data('product');


        switch (product){


            case 'onefit':

            // VSL
            $('#unicorn-banner').hide();
            var onefitVSLKey = 'VqgVDzoqdrCQFJBSFNgEsLkXJDpXL1ulsXw1SMaCGXA';
            var oneFitVSLThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneFit_VSL_Thumbnail.webp?v=1777876347';

            $('#unicorn-banner').after(`<div class="unicorn-quiz-widget" data-widget="vsl">
                <div class="review-pop-item" data-key="${onefitVSLKey}">
                    <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                    <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                    <img class="video-thumbnail" src="${oneFitVSLThumbnail}">
                </div>
                
            </div>
            `).fadeIn(300);

            break;

            case 'onelife':

                var onefitVSLKey = 'juIoNJ9aQNp00yP02c3wv01HC8btcQg13iAYGOxBdzv5Kc';
                var oneFitVSLThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife_Thumbnail_VSL.webp?v=1777876637';

                // VSL
                $('#unicorn-banner').hide();
                $('#unicorn-banner').after(`<div class="unicorn-quiz-widget" data-widget="vsl">
                    <div class="review-pop-item" data-key="${onefitVSLKey}">
                        <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                        <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                        <img class="video-thumbnail" src="${oneFitVSLThumbnail}">
                    </div>
                    
                </div>
                `).fadeIn(300);

            break;

            case 'comprehensive':

                // VSL
                $('#unicorn-banner').hide();

                $('#unicorn-banner').after(`<div class="unicorn-quiz-widget" data-widget="vsl">
                        <div class="review-pop-item" data-key="Zyr3P63JzH9h02Fj9njLUuoStMwXwrx3m291B6gsWaYc">
                        <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                        <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                        <img class="video-thumbnail" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Comprehensive_VSL_Thumbnail.webp?v=1777876347">
                </div>
                    
            </div>
            `).fadeIn(300);

            break;

            

        }

        


        // if (product == 'onelife' || product == 'comprehensive'){

        //     showOutOfStockPopup(product);

        // }else{


            // $('.product-buy-card').removeClass('active').hide();
            // $('.product-buy-plan > div').removeClass('active')
            
            $(this).siblings().removeClass('active');
            $(this).addClass('active');


            
            // Open Pathway
            $('body').addClass('pathway-info-opened');
            $('.pathway-popup[data-product="'+product+'"]').addClass('active').siblings().removeClass('active');
            


            hidePathwayPanels();

            $('.continue-with-plan-wrapper').attr('data-parent-fade-out-animating', '');

            setTimeout(function(){
                setPathwayProgressBar(20);

                // alert($('.pathway-popup.active').scrollTop());

                var $popup = $('.pathway-popup.active');
                if ($popup.scrollTop() > 0) {
                    $popup.animate({ scrollTop: 0 }, 400);
                    console.warn('Should scroll top');
                }

                // $('.pathway-popup.active').animate({ scrollTop: 0 }, 600);
            },500);



            // setTimeout(() => {
            //     $('.unicorn-buy-panel[data-panel="main"]').fadeOut(300).removeClass('active');

            //     $('.sticky-unicorn-selector').addClass('active');
            //     $(`.unicorn-buy-panel[data-panel="${product}"]`).fadeIn(300).addClass('active');

            //     $(`.unicorn-buy-panel[data-panel="${product}"] .product-buy-plan div`).first().trigger('click');

            //     $('body').addClass('body-stick-unicorn-selector');

            // }, 500);

        // }


    });

    // Product Offer Panel
    $(document).on('click','.product-buy-plan > div',function(){
        
        const parent = $('.unicorn-buy-product-panel.unica');
        const panel = parent.data('panel');
        const plan = $(this).data('plan');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        parent.find('.product-buy-card').fadeOut(300).removeClass('active');
        parent.find('.product-buy-card[data-plan="'+plan+'"]').fadeIn(300).addClass('active');

        // $('.quiz-cart .product-buy-card').removeClass('super-active');
        // $('.quiz-cart .unicorn-buy-panel').removeClass('unica');

        // $('.quiz-cart [data-panel="'+panel+'"] [data-plan]').addClass('super-active animate-super-active-done');
        // $('.quiz-cart [data-panel="'+panel+'"]').addClass('unica');


    });
    $(document).on('click','.product-buy-cards > div',function(){
        
        const parent = $(this).parents('.unicorn-buy-product-panel');
        const plan = $(this).data('plan');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        parent.find('.product-buy-card').removeClass('active');
        parent.find('.product-buy-card[data-plan="'+plan+'"]').addClass('active');


    });

    // Back to main
    $(document).on('click','.product-change-my-path button',function(){
        
        var btn = $(this);
        btn.addClass('active');

        // Hide Selectors
        $('.product-onefit-flavour').removeClass('active');

        setTimeout(() => {
            
            $('.sticky-unicorn-selector').removeClass('active');
            $('body').removeClass('body-stick-unicorn-selector');

            $('.unicorn-buy-panel').not($('.unicorn-buy-panel[data-panel="main"]')).fadeOut(300).removeClass('active');
            $('.unicorn-buy-panel[data-panel="main"]').fadeIn(300);
            
            $('.buy-options .option').removeClass('active');

            $('html, body').animate({
                scrollTop: $('.unicorn-buy-panel[data-panel="main"]').offset().top - 120
            }, 600); // 600ms smooth scroll

            setTimeout(() => {
                btn.removeClass('active');
            },1000);

            $('#unicorn-banner').html('<img class="br-4" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Choose_Your_Path.png?v=1777508745">').show();

            $('body').removeClass('quiz-enabled');
            $('.unicorn-buy-panel[data-panel="quiz"]').removeClass('animating');

        }, 500);

    });

    var isQuiz = false;
    var isQuizUpsell = false;

    $(document).on('click','.btn-product-checkout',function(){

        isQuiz = false;

        var panel = $('.unicorn-buy-product-panel.active');
        var product = panel.data('panel');

        isQuizUpsell = true;
        

        if (product == 'onefit'){
            openOnelifeUpsell();
        }else if (product == 'onelife'){
            openOnefitUpsell();
        }else{

            processCheckout(panel);
            

            setTimeout(() => {
                $('.unicorn-buy-panel').not($('.unicorn-buy-panel[data-panel="cart"]')).fadeOut(600).removeClass('active');
                $('.unicorn-buy-panel[data-panel="cart"]').fadeIn(600,function(){
                    $('html, body').animate({
                        scrollTop: $('.section-unicorn-buy').offset().top - 100
                    }, 600); // 600ms smooth scroll
                }).addClass('active');

                // $('.unicorn-buy-panel-cart').scrollTop(0);
                

            }, 500);
        }
    
        
        
    });

    function processCheckout(panel){

        var product = panel.data('panel');
        var card = panel.find('.product-buy-card.active');
        
        switch (product){
            case 'comprehensive':
                processComprehensive(card);
            break;
            case 'onefit':
                processOneFit(card);
            break;
            case 'onelife':
                processOneLife(card);
            break;
        }
        
    }

    $(document).on('click','.btn-product-checkout-quiz',function(){

        isQuiz = true;


        $('body').removeClass('quiz-enabled');

        var panel = $('.quiz-cart .super-active').parents('.unicorn-buy-product-panel');
        var product = panel.data('panel');
        
        // if (product == 'onelife' || product == 'comprehensive'){

        //     showOutOfStockPopup(product);

        // }else{

            setTimeout(() => {


                processCheckoutQuiz(panel);

                $('.unicorn-buy-panel').not($('.unicorn-buy-panel[data-panel="cart"]')).fadeOut(600).removeClass('active');
                $('.unicorn-buy-panel[data-panel="cart"]').fadeIn(600,function(){
                    $('html, body').animate({
                        scrollTop: $('.section-unicorn-buy').offset().top - 100
                    }, 600); // 600ms smooth scroll
                }).addClass('active');

                $('body').removeClass('quiz-enabled');
                $('.unicorn-buy-panel[data-panel="quiz"]').removeClass('animating');
                

                $('.unicorn-buy-panel-cart').scrollTop(0);
                
                

            }, 500);

        // }
    });

    function processCheckoutQuiz(panel){

        var product = panel.data('panel');
        var activePlan = $("#quiz-product-buy-options .product-buy-plan .active").data('plan');


        var card = panel.find('.quiz-cart .product-buy-card[data-plan="'+activePlan+'"]');

        switch (product){
            case 'comprehensive':
                // showOutOfStockPopup(product);
                processComprehensive(card);
            break;
            case 'onefit':
                processOneFit(card);
            break;
            case 'onelife':
                // showOutOfStockPopup(product);
                processOneLife(card);
            break;
        }

    
        
    }

    var payload = {};

    function processComprehensive(card){


       
        var panel = $('.unicorn-buy-product-panel.active').first();
        var card = panel.find('.product-buy-card.active').first();
        
        if (isQuiz){
            panel = $('.quiz-cart .super-active').parents('.unicorn-buy-product-panel');
            card = panel.find('.product-buy-card.active.super-active');
        }


        var html = '';
        var plan = card.data('plan');

        var perDay = card.find('.plan-price h3').html();
        
        var onefitFlavour = card.find('.plan-flavour-dropdown option:selected').text();
        var onefitFlavour = card.find('.plan-flavour-dropdown option:selected').text();
        var billedTotalValue = card.find('.billed-total-value').text();
        var billedTotalCurrency = card.find('.billed-total-currency').text();

        $('.unicorn-cart').empty();


        var form = card.find('.plan-buy-form');
        

        var quizHead = isQuiz
  ? `
    <h2>Lock In Your <span class="d-block">Personalised plan</span></h2>
  `
  : `<h2>Complete Your Order</h2>`;
        switch (plan){
            case '90d':
                html = `
                    
                
                    ${quizHead}

                    
                    <div class="unicorn-cart-video">
                    <p>See How Complete System Fits into Your Day</p>
                   
                    <div class="unicorn-quiz-widget" data-widget="vsl">


                       

                        <div class="review-pop-item" data-key="Zyr3P63JzH9h02Fj9njLUuoStMwXwrx3m291B6gsWaYc">
                            <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                            <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                            <img class="video-thumbnail" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Jonna.png?v=1777001630">
                        </div>
                        
                    </div>
                    
                    </div>

                <div class="unicorn-cart-line-items">
                  
                  
                    ${lineItemComponent('onefit','OneFit (90 Sachets)',onefitFlavour)}
                    ${lineItemComponent('onelife','OneLife (90 Serves)','Watermelon')}
                    ${lineItemComponent('bottle','FON Premium Bottle',3)}

                </div>


                <div class="unicorn-cart-line-summary">
                  <div class="cart-line-summary">

                      <div class="line">
                        <span>Supply</span>
                        <span class="line-supply">90 Daily Serves of OneFit & OneLife</span>
                      </div>
                      <div class="line">
                        <span>Daily Price</span>
                        <span class="line-daily">${perDay} per day</span>
                      </div>
                      <div class="line">
                        <span>Shipping</span>
                        <span class="line-supply">Priority Included</span>
                      </div>

                  </div>
                  <div class="cart-line-total">
                    <h3>TOTAL</h3>
                    <p>${billedTotalValue} ${billedTotalCurrency}</p>
                  </div>
                </div>

                <div class="unicorn-cart-line-action">
                  <button id="btn-checkout-now">Checkout ${billedTotalValue}</button>
                  <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Accepted_Payment.png?v=1776843177" width="175">
                </div>
                `;


                var formOneFit = form.find('[name="comprehensive-90d-onefit"]');
                var formOneFitVariantID = formOneFit.val();
                var formOneFitSellingPlanID = formOneFit.find('option:selected').data('selling-plan-id');
                var formOneFitQty = formOneFit.data('qty');

                var formOneLife = form.find('[name="comprehensive-90d-onelife"]');
                var formOneLifeVariantID = formOneLife.val();
                var formOneLifeSellingPlanID = formOneLife.data('selling-plan-id');
                var formOneLifeQty = formOneLife.data('qty');


                var formBottle = form.find('[name="comprehensive-90d-bottle"]');
                var formBottleVariantID = formBottle.val();
                var formBottleQty = formBottle.data('qty');

                var formFrother = form.find('[name="comprehensive-90d-frother"]');
                var formFrotherVariantID = formFrother.val();
                var formFrotherQty = formFrother.data('qty');

                var formData = {
                    items: [
                        {
                        id: formOneFitVariantID,
                        quantity: formOneFitQty,
                        selling_plan: formOneFitSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'comprehensive_90d',
                            '_bundle_group_id' : 'comprehensive_90d_' + formOneFitVariantID,
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            "_bundle_group_product_multiplier" : formOneFitQty,
                            '_offer' : 'comprehensive_90d_' + formOneFitVariantID,
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'unicorn-comprehensive-' + orderFromValue
                        }
                        }
                    ]
                };

                formData.items.push({
                    id: formOneLifeVariantID,
                    quantity: formOneLifeQty,
                    selling_plan: formOneLifeSellingPlanID,
                    properties : {
                        '_BUNDLE' : 'comprehensive_90d',
                        '_bundle_group_id' : 'comprehensive_90d_' + formOneFitVariantID,
                        "_bundle_group_product" : true,
                        "_bundle_group_product_row" : 2,
                        "_bundle_group_product_multiplier" : formOneLifeQty,
                        '_offer' : 'comprehensive_90d_' + formOneLifeVariantID,
                        '_offer_product_type' : 'primary',
                        '_order_from' : 'unicorn-comprehensive-' + orderFromValue
                    }
                });

                if (false && !bottleOOS) /*free gift off*/ {
                    formData.items.push({
                        id: formBottleVariantID, // Free bottle variant ID
                        quantity: formBottleQty,
                        properties : {
                            '_offer' : 'comprehensive_90d_' + formOneFitVariantID,
                            '_offer_product_type' : 'free',
                        }
                    });
                }

                // if (false && !frotherOOS) /*free gift off*/ {
                //     formData.items.push({
                //         id: formFrotherVariantID, // Free frother variant ID
                //         quantity: formFrotherQty,
                //         properties : {
                //             '_offer' : 'comprehensive_90d_' + formOneFitVariantID,
                //             '_offer_product_type' : 'free',
                //         }
                //     });
                // }
                payload = formData;

                console.log('formData',formData);

            break;
            case '30d':


                html = `
                    ${quizHead}

                    
                    <div class="unicorn-cart-video">
                    <p>See How Complete System Fits into Your Day</p>
                   
                    <div class="unicorn-quiz-widget" data-widget="vsl">


                       

                        <div class="review-pop-item" data-key="Zyr3P63JzH9h02Fj9njLUuoStMwXwrx3m291B6gsWaYc">
                            <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                            <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                            <img class="video-thumbnail" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Jonna.png?v=1777001630">
                        </div>
                        
                    </div>
                    </div>

                <div class="unicorn-cart-line-items">
                  
                  
                    ${lineItemComponent('onefit','OneFit (30 Sachets)',onefitFlavour)}
                    ${lineItemComponent('onelife','OneLife (30 Serves)','Watermelon')}

                </div>


                <div class="unicorn-cart-line-summary">
                  <div class="cart-line-summary">

                      <div class="line">
                        <span>Supply</span>
                        <span class="line-supply">30 Daily Serves of OneFit & OneLife</span>
                      </div>
                      <div class="line">
                        <span>Daily Price</span>
                        <span class="line-daily">${perDay} per day</span>
                      </div>
                      <div class="line">
                        <span>Shipping</span>
                        <span class="line-supply">Priority Included</span>
                      </div>

                  </div>
                  <div class="cart-line-total">
                    <h3>TOTAL</h3>
                    <p>${billedTotalValue} ${billedTotalCurrency}</p>
                  </div>
                </div>

                <div class="unicorn-cart-line-action">
                  <button id="btn-checkout-now">Checkout ${billedTotalValue}</button>
                  <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Accepted_Payment.png?v=1776843177" width="175">
                </div>
                `;


                var formOneFit = form.find('[name="comprehensive-30d-onefit"]');
                var formOneFitVariantID = formOneFit.val();
                var formOneFitSellingPlanID = formOneFit.data('selling-plan-id');
                var formOneFitQty = formOneFit.data('qty');

                var formOneLife = form.find('[name="comprehensive-30d-onelife"]');
                var formOneLifeVariantID = formOneLife.val();
                var formOneLifeSellingPlanID = formOneLife.data('selling-plan-id');
                var formOneLifeQty = formOneLife.data('qty');


                var formData = {
                    items: [
                        {
                        id: formOneFitVariantID,
                        quantity: formOneFitQty,
                        // selling_plan: formOneFitSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'comprehensive_30d',
                            '_bundle_group_id' : 'comprehensive_30d_' + formOneFitVariantID,
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            "_bundle_group_product_multiplier" : formOneFitQty,
                            '_offer' : 'comprehensive_30d_' + formOneFitVariantID,
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'unicorn-comprehensive-' + orderFromValue
                        }
                        }
                    ]
                };

                formData.items.push({
                    id: formOneLifeVariantID,
                    quantity: formOneLifeQty,
                    // selling_plan: formOneLifeSellingPlanID,
                    properties : {
                        '_BUNDLE' : 'comprehensive_30d',
                        '_bundle_group_id' : 'comprehensive_30d_' + formOneFitVariantID,
                        "_bundle_group_product" : true,
                        "_bundle_group_product_row" : 2,
                        "_bundle_group_product_multiplier" : formOneLifeQty,
                        '_offer' : 'comprehensive_30d_' + formOneLifeVariantID,
                        '_offer_product_type' : 'primary',
                        '_order_from' : 'unicorn-comprehensive-' + orderFromValue
                    }
                });

                payload = formData;

                console.log('formData',formData);
                
                

            break;
        }

        $('.unicorn-cart').html(html);

    }


    function lineItemComponent(product,label = 'OneFit', flavour = '', quantity = ''){
        switch (product){
            case 'onefit':

                flavour = flavour.trim();

                var onefitThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Choc_Milkshake_box_1500x1500-removebg-preview.png?v=1777851476';
                switch (flavour){
                    case 'Chocolate Milkshake':
                        onefitThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Choc_Milkshake_box_1500x1500-removebg-preview.png?v=1777851476';
                    break;
                    case 'Tropical Crush':
                        onefitThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_TC.png?v=1777851907';
                    break;
                    case 'Vanilla Ice Cream':
                        onefitThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_FV.png?v=1777851907';
                    break;
                    case 'Plant-based French Vanilla':
                        onefitThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_Plant_Vanilla.png?v=1777851907';
                    break;
                    case 'Plant-based Cacao':
                        onefitThumbnail = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_Plant_Cacao.png?v=1777851907';
                    break;
                }
                return `
                    <div class="line-item">
                        <div class="image">
                            <img src="${onefitThumbnail}"/>
                        </div>
                        <div class="text">
                            <h3>${label}</h3>
                            <p>${flavour}</p>
                        </div>
                        <div class="check">
                            <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/mdi_tick_1.svg?v=1776842960" width="25">
                        </div>
                    </div>
                `;
            break;
            case 'onelife':
                return `
                    <div class="line-item">
                        <div class="image">
                        <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562"/>
                        </div>
                        <div class="text">
                        <h3>${label}</h3>
                        <p>${flavour}</p>
                        </div>
                        <div class="check">
                        <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/mdi_tick_1.svg?v=1776842960" width="25">
                        </div>
                    </div>
                `;
            break;
            case 'bottle':
                return `
                    <div class="line-item">
                        <div class="image">
                        <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925"/>
                        </div>
                        <div class="text">
                        <h3>${quantity} ${label}</h3>
                        <p>VIP Welcome Kit</p>
                        </div>
                        <div class="check">
                        <span>FREE</span>
                        </div>
                    </div>
                `;
            break;
            case 'frother':
                return `
                    <div class="line-item">
                        <div class="image">
                        <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925"/>
                        </div>
                        <div class="text">
                        <h3>${quantity} ${label}</h3>
                        <p>VIP Welcome Kit</p>
                        </div>
                        <div class="check">
                        <span>FREE</span>
                        </div>
                    </div>
                `;
            break;
        }
    }

    function processOneFit(plan){
        
        var panel = $('.unicorn-buy-product-panel.active').first();
        var card = panel.find('.product-buy-card.active').first();

        card.addClass('test134');

        if (isQuiz){
            panel = $('.quiz-cart .super-active').parents('.unicorn-buy-product-panel');
            card = panel.find('.product-buy-card.active.super-active');
        }

        

        var html = '';
        var plan = card.data('plan');


        var perDay = card.find('.plan-price h3').html();
        var form = card.find('.plan-buy-form');
        var onefitFlavour = card.find('.plan-flavour-dropdown option:selected').text();


        var billedTotalValue = card.find('.billed-total-value').text();
        var billedTotalCurrency = card.find('.billed-total-currency').text();


        var selectedOneFitVariantSKU = $('.swatch-container.selected-flavour span').data('variant-sku');


        var onefitVSLKey = 'VqgVDzoqdrCQFJBSFNgEsLkXJDpXL1ulsXw1SMaCGXA';
        var oneFitVSLThumbnail = 'https://image.mux.com/VqgVDzoqdrCQFJBSFNgEsLkXJDpXL1ulsXw1SMaCGXA/thumbnail.png?width=495&height=254&fit_mode=crop';

        if (selectedOneFitVariantSKU == 'OF-FV-BOX-700-V4.6' || selectedOneFitVariantSKU == 'OF-CO-BOX-700-V4.6'){
            onefitVSLKey = 'IBGYy8qWmPhPWvij00MQl2rKbI99EzJs3NT1D00uo3PyA';
            oneFitVSLThumbnail = 'https://image.mux.com/IBGYy8qWmPhPWvij00MQl2rKbI99EzJs3NT1D00uo3PyA/thumbnail.png?width=495&height=254&fit_mode=smartcrop';
        }
        


        $('.unicorn-cart').empty();


 var quizHead = isQuiz
  ? `
    <h2>Lock In Your <span class="d-block">Personalised plan</span></h2>
  `
  : `<h2>Complete Your Order</h2>`;

        switch (plan){
            case '90d':
                html = `
                    ${quizHead}

                    
                    <div class="unicorn-cart-video">
                    <p>See How OneFit® Fits into Your Day</p>
                    
                    <div class="unicorn-quiz-widget" data-widget="vsl">


                       

                        <div class="review-pop-item" data-key="${onefitVSLKey}">
                            <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                            <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                            <img class="video-thumbnail" src="${oneFitVSLThumbnail}">
                        </div>
                        
                    </div>
                    
                    </div>

                <div class="unicorn-cart-line-items">
                  
                  
                    ${lineItemComponent('onefit','OneFit (90 Sachets)',onefitFlavour)}
                    ${lineItemComponent('bottle','FON Premium Bottle',1)}

                </div>


                <div class="unicorn-cart-line-summary">
                  <div class="cart-line-summary">

                      <div class="line">
                        <span>Supply</span>
                        <span class="line-supply">90 Daily Serves of OneFit</span>
                      </div>
                      <div class="line">
                        <span>Daily Price</span>
                        <span class="line-daily">${perDay} per day</span>
                      </div>
                      <div class="line">
                        <span>Shipping</span>
                        <span class="line-supply">Priority Included</span>
                      </div>

                  </div>
                  <div class="cart-line-total">
                    <h3>TOTAL</h3>
                    <p>${billedTotalValue} ${billedTotalCurrency}</p>
                  </div>
                </div>

                <div class="unicorn-cart-line-action">
                  <button id="btn-checkout-now">Checkout ${billedTotalValue}</button>
                  <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Accepted_Payment.png?v=1776843177" width="175">
                </div>
                `;

                form.addClass('working');
                var formOneFit = form.find('[name="onefit-90d-product"]');
                var formOneFitVariantID = formOneFit.val();
                var formOneFitSellingPlanID = formOneFit.find('option:selected').data('selling-plan-id');

        

                var formOneFitQty = formOneFit.data('qty');

                var formBottle = form.find('[name="onefit-90d-bottle"]');
                var formBottleVariantID = formBottle.val();
                var formBottleQty = formBottle.data('qty');

                var formFrother = form.find('[name="onefit-90d-frother"]');
                var formFrotherVariantID = formFrother.val();
                var formFrotherQty = formFrother.data('qty');

                var formData = {
                    items: [
                        {
                        id: formOneFitVariantID,
                        quantity: formOneFitQty,
                        selling_plan: formOneFitSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'onefit_90d',
                            '_bundle_group_id' : 'onefit_90d_' + formOneFitVariantID,
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onefit_90d_' + formOneFitVariantID,
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'unicorn-onefit-' + orderFromValue
                        }
                        }
                    ]
                };


                if (false && !bottleOOS) /*free gift off*/ {
                    formData.items.push({
                        id: formBottleVariantID, // Free bottle variant ID
                        quantity: formBottleQty,
                        properties : {
                            '_offer' : 'onefit_90d_' + formOneFitVariantID,
                            '_offer_product_type' : 'free',
                        }
                    });
                }

                // if (false && !frotherOOS) /*free gift off*/ {
                //     formData.items.push({
                //         id: formFrotherVariantID, // Free frother variant ID
                //         quantity: formFrotherQty,
                //         properties : {
                //             '_offer' : 'onefit_90d_' + formOneFitVariantID,
                //             '_offer_product_type' : 'free',
                //         }
                //     });
                // }
                payload = formData;

                console.log('formData',formData);

            break;
            case '30d':


                html = `
                    ${quizHead}

                    
                    <div class="unicorn-cart-video">
                    <p>See How OneFit® Fits into Your Day</p>
                    
                    <div class="unicorn-quiz-widget" data-widget="vsl">


                       

                        <div class="review-pop-item" data-key="${onefitVSLKey}">
                            <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                            <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                            <img class="video-thumbnail" src="${oneFitVSLThumbnail}">
                        </div>
                        
                    </div>
                    
                    </div>

                <div class="unicorn-cart-line-items">
                  
                  
                    ${lineItemComponent('onefit','OneFit (20 Sachets)',onefitFlavour)}

                </div>


                <div class="unicorn-cart-line-summary">
                  <div class="cart-line-summary">

                      <div class="line">
                        <span>Supply</span>
                        <span class="line-supply">20 Daily Serves of OneFit</span>
                      </div>
                      <div class="line">
                        <span>Daily Price</span>
                        <span class="line-daily">${perDay} per day</span>
                      </div>
                      <div class="line">
                        <span>Shipping</span>
                        <span class="line-supply">Priority Included</span>
                      </div>

                  </div>
                  <div class="cart-line-total">
                    <h3>TOTAL</h3>
                    <p>${billedTotalValue} ${billedTotalCurrency}</p>
                  </div>
                </div>

                <div class="unicorn-cart-line-action">
                  <button id="btn-checkout-now">Checkout ${billedTotalValue}</button>
                  <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Accepted_Payment.png?v=1776843177" width="175">
                </div>
                `;

                var formOneFit = form.find('[name="onefit-30d-product"]');
                var formOneFitVariantID = formOneFit.val();
                var formOneFitSellingPlanID = formOneFit.data('selling-plan-id');
                var formOneFitQty = formOneFit.data('qty');

                var formData = {
                    items: [
                        {
                        id: formOneFitVariantID,
                        quantity: formOneFitQty,
                        selling_plan: formOneFitSellingPlanID,
                        properties : {
                            '_offer' : 'unicorn_onefit_30d_' + formOneFitVariantID,
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'unicorn-onefit-' + orderFromValue
                        }
                        }
                    ]
                };

                payload = formData;

                console.log('formData',formData);
                
            break;
        }

        $('.unicorn-cart').html(html);
    }
    function processOneLife(plan){


        var panel = $('.unicorn-buy-product-panel.active').first();
        var card = panel.find('.product-buy-card.active').first();

        if (isQuiz){
            panel = $('.quiz-cart .super-active').parents('.unicorn-buy-product-panel');
            card = panel.find('.product-buy-card.active.super-active');
        }
        
       

        var html = '';
        var plan = card.data('plan');

        var perDay = card.find('.plan-price h3').html();
        var form = card.find('.plan-buy-form');
        var onefitFlavour = card.find('.plan-flavour-dropdown option:selected').text();
        var billedTotalValue = card.find('.billed-total-value').text();


        var billedTotalCurrency = card.find('.billed-total-currency').text();

        var onefitVSLKey = 'juIoNJ9aQNp00yP02c3wv01HC8btcQg13iAYGOxBdzv5Kc';
        var oneFitVSLThumbnail = 'https://image.mux.com/juIoNJ9aQNp00yP02c3wv01HC8btcQg13iAYGOxBdzv5Kc/thumbnail.png?width=495&height=254&fit_mode=crop&time=13';

      


        $('.unicorn-cart').empty();

var quizHead = isQuiz
  ? `
    <h2>Lock In Your <span class="d-block">Personalised plan</span></h2>
  `
  : `<h2>Complete Your Order</h2>`;

        switch (plan){
            case '90d':
                html = `
                    ${quizHead}

                    
                    <div class="unicorn-cart-video">
                    <p>See How OneLife™ Fits into Your Day</p>
                    
                    <div class="unicorn-quiz-widget" data-widget="vsl">


                       

                        <div class="review-pop-item" data-key="${onefitVSLKey}">
                            <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                            <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                            <img class="video-thumbnail" src="${oneFitVSLThumbnail}">
                        </div>
                        
                    </div>
                    </div>

                <div class="unicorn-cart-line-items">
                  
                  
                    ${lineItemComponent('onelife','OneLife (90 Serves)','Watermelon')}
                    ${lineItemComponent('bottle','FON Premium Bottle',3)}

                </div>


                <div class="unicorn-cart-line-summary">
                  <div class="cart-line-summary">

                      <div class="line">
                        <span>Supply</span>
                        <span class="line-supply">90 Daily Serves of OneLife</span>
                      </div>
                      <div class="line">
                        <span>Daily Price</span>
                        <span class="line-daily">${perDay} per day</span>
                      </div>
                      <div class="line">
                        <span>Shipping</span>
                        <span class="line-supply">Priority Included</span>
                      </div>

                  </div>
                  <div class="cart-line-total">
                    <h3>TOTAL</h3>
                    <p>${billedTotalValue} ${billedTotalCurrency}</p>
                  </div>
                </div>

                <div class="unicorn-cart-line-action">
                  <button id="btn-checkout-now">Checkout ${billedTotalValue}</button>
                  <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Accepted_Payment.png?v=1776843177" width="175">
                </div>
                `;

                var formOneLife = form.find('[name="onelife-90d-product"]');
                var formOneLifeVariantID = formOneLife.val();
                var formOneLifeSellingPlanID = formOneLife.find('option:selected').data('selling-plan-id');
                var formOneLifeQty = formOneLife.data('qty');

                var formBottle = form.find('[name="onelife-90d-bottle"]');
                var formBottleVariantID = formBottle.val();
                var formBottleQty = formBottle.data('qty');

                var formFrother = form.find('[name="onelife-90d-frother"]');
                var formFrotherVariantID = formFrother.val();
                var formFrotherQty = formFrother.data('qty');

                var formData = {
                    items: [
                        {
                        id: formOneLifeVariantID,
                        quantity: formOneLifeQty,
                        selling_plan: formOneLifeSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'onelife_90d',
                            '_bundle_group_id' : 'onelife_90d_' + formOneLifeVariantID,
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onelife_90d_' + formOneLifeVariantID,
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'unicorn-onelife-' + orderFromValue
                        }
                        }
                    ]
                };


                if (false && !bottleOOS) /*free gift off*/ {
                    formData.items.push({
                        id: formBottleVariantID, // Free bottle variant ID
                        quantity: formBottleQty,
                        properties : {
                            '_offer' : 'onelife_90d_' + formOneLifeVariantID,
                            '_offer_product_type' : 'free',
                        }
                    });
                }

                // if (false && !frotherOOS) /*free gift off*/ {
                //     formData.items.push({
                //         id: formFrotherVariantID, // Free frother variant ID
                //         quantity: formFrotherQty,
                //         properties : {
                //             '_offer' : 'onelife_90d_' + formOneLifeVariantID,
                //             '_offer_product_type' : 'free',
                //         }
                //     });
                // }
                payload = formData;

                console.log('formData',formData);

            break;
            case '30d':


                html = `
                    ${quizHead}

                    <div class="unicorn-cart-video">
                  
                    <p>See How OneLife™ Fits into Your Day</p>
                   <div class="unicorn-quiz-widget" data-widget="vsl">


                       

                        <div class="review-pop-item" data-key="${onefitVSLKey}">
                            <img class="full-screen-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Full_Screen.svg?v=1777001813">
                            <img class="play-icon" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/VSL_Play_Icon_422a3f27-c846-4b96-b586-04e648052035.png?v=1777514543">
                            <img class="video-thumbnail" src="${oneFitVSLThumbnail}">
                        </div>
                        
                    </div>
                    </div>

                <div class="unicorn-cart-line-items">
                  
                  
                    ${lineItemComponent('onelife','OneLife (30 Serves)','Watermelon')}

                </div>


                <div class="unicorn-cart-line-summary">
                  <div class="cart-line-summary">

                      <div class="line">
                        <span>Supply</span>
                        <span class="line-supply">30 Daily Serves OneLife</span>
                      </div>
                      <div class="line">
                        <span>Daily Price</span>
                        <span class="line-daily">${perDay} per day</span>
                      </div>
                      <div class="line">
                        <span>Shipping</span>
                        <span class="line-supply">Priority Included</span>
                      </div>

                  </div>
                  <div class="cart-line-total">
                    <h3>TOTAL</h3>
                    <p>${billedTotalValue} ${billedTotalCurrency}</p>
                  </div>
                </div>

                <div class="unicorn-cart-line-action">
                  <button id="btn-checkout-now">Checkout ${billedTotalValue}</button>
                  <img src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Accepted_Payment.png?v=1776843177" width="175">
                </div>
                `;


                var formOneLife = form.find('[name="onelife-30d-product"]');
                var formOneLifeVariantID = formOneLife.val();
                var formOneLifeQty = formOneLife.data('qty');

                var formData = {
                    items: [
                        {
                        id: formOneLifeVariantID,
                        quantity: formOneLifeQty,
                        properties : {
                            '_offer' : 'unicorn_onelife_30d_' + formOneLifeVariantID,
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'unicorn-onelife-' + orderFromValue
                        }
                        }
                    ]
                };
                payload = formData;

                console.log('formData',formData);
                
            break;
        }

        $('.unicorn-cart').html(html);
    }


    let current = 0;
    function nextReview() {
        const $items = $('#unicorn-review .review-item');
        $items.eq(current).fadeOut(400, function() {
            $(this).removeClass('active');
            current = (current + 1) % $items.length;
            $items.eq(current).addClass('active').fadeIn(400);
        });
    }
    
    $(document).on('click','#btn-quiz, [href="#take-a-quiz"], .btn-other-path-quiz',function(){

        nextReview();

        // $('#unicorn-quiz-wrapper').addClass('unicorn-quiz-active');
        setTimeout(() => {

            $('body').addClass('quiz-enabled');
            
            $('.sticky-unicorn-selector').removeClass('active');
            $('body').removeClass('body-stick-unicorn-selector');

            
            // $('.unicorn-buy-panel').not($('.unicorn-buy-panel[data-panel="quiz"]')).fadeOut();
            $('.unicorn-buy-panel[data-panel="quiz"]').show().removeClass('animating');

            setTimeout(function(){
                $('.unicorn-buy-panel[data-panel="quiz"]').addClass('animating');
            },300);

            
            // showPanel('quiz');

            // Temporary skip panels
            // hidePanel('start');
            // showPanel('matter');


            
            $('.buy-options .option').removeClass('active');

            $('html, body').animate({
                scrollTop: $('#get-started').offset().top - 120
            }, 600); // 600ms smooth scroll
            

            $('.product-onefit-flavour-quiz').removeClass('active');
            $('.pathway-popup').removeClass('active');

            

        }, 300);


    });

    // Quiz Toggle
    // $('#btn-quiz').trigger('click');


    $(document).on('click','.unicorn-quiz-heading .close',function(){
        // $('#unicorn-quiz-wrapper').removeClass('unicorn-quiz-active');

        setTimeout(() => {
            
            $('.sticky-unicorn-selector').removeClass('active');
            $('body').removeClass('body-stick-unicorn-selector');

            $('.unicorn-buy-panel').not($('.unicorn-buy-panel[data-panel="main"]')).fadeOut(600).removeClass('active');
            // $('.unicorn-buy-panel[data-panel="main"]').fadeIn(300);
            
            $('.buy-options .option').removeClass('active');

            $('html, body').animate({
                scrollTop: $('.unicorn-buy-panel[data-panel="main"]').offset().top - 120
            }, 600); // 600ms smooth scroll

            $('body').removeClass('quiz-enabled');
            $('.unicorn-buy-panel[data-panel="quiz"]').removeClass('animating');

            

        }, 300);

    });


    // Next Panel
    var preferredProduct = 'onefit';
    var swiperEducationComprehensive;
    var swiperEducationComprehensiveStatus = false;


    var swiperEducationOneLife;
    var swiperEducationOneLifeStatus = false;

    var swiperEducationOneFit;
    var swiperEducationOneFitStatus = false;


    $(document).on('click','.btn-next-panel',function(){

        $('.swiper').removeClass('onefit-mode');

        const parent  = $(this).parents('.unicorn-quiz-panel');
        const panel = parent.data('panel');

        nextReview();


        // Pause Any MUX
        const $parent = $('#unicorn-quiz-wrapper');

        $parent.find('mux-player').each(function () {
            this.pause();
            $(this).parent('.fon-video-lazy-container').removeClass('playing');
        });
       
            

        switch (panel){

            


            case 'start':

                hidePanel(panel);
                showPanel('goal');

                // DEV TEST
                // hidePanel(panel);
                // showPanel('matter');
                // preferredProduct = 'onelife';


                // DEV TST
                // var chosenProduct = 'onefit';

                // if (chosenProduct == 'onelife'){
                //     $('.product-onefit-flavour-quiz').addClass('d-none');
                // }else{
                //     $('.product-onelife-flavour-quiz').removeClass('d-none');
                // }

                // hidePanel(panel);
                // showPanel('checkout');

                // $('.quiz-cart .product-buy-card').removeClass('super-active');
                // $('.quiz-cart .unicorn-buy-panel').removeClass('unica');

                // $('.quiz-cart [data-panel="'+chosenProduct+'"] [data-plan]').addClass('super-active animate-super-active-done');
                // $('.quiz-cart [data-panel="'+chosenProduct+'"]').addClass('unica');

                // $('.quiz-cart > div').show();
                // $('#quiz-product-buy-options [data-plan="90d"]').trigger('click');


                // animateCounters(chosenProduct);


                // // Aply Selection
                // quizSelections.status = 'completed';
                // applySelectionsToCart();

                // $('.flavour-options-wrapper').slideUp();
                // $('.quiz-cart-product-offers').removeClass('active');
                // $('.quiz-cart-' + chosenProduct).addClass('active');

               

            break;
            case 'goal':

                preferredProduct = 'onefit';

                var activeGoal = $('[data-action="goal"] .quiz-choice.active h3').html().trim();
                if (activeGoal == "I'm playing the long game"){
                    preferredProduct = 'onelife';
                }
                if (activeGoal == "All of the above"){
                    preferredProduct = 'comprehensive';
                }


                hidePanel(panel);
                showPanel('after-goal-vsl');

                $('[data-panel="after-goal-vsl"] .fon-video-play').trigger('click');

                

            break;

            case 'after-goal-vsl':

                hidePanel(panel);
                showPanel('exercise');

            break;

            case 'exercise':

                var exercise = $('[data-action="exercise"] .quiz-choice.active h3').html().trim();
                if (preferredProduct == 'onefit' && exercise == "Occasionally or Never"){
                    preferredProduct = 'comprehensive';
                }

                if (preferredProduct == 'onelife' && exercise != "Occasionally or Never"){
                    preferredProduct = 'comprehensive';
                }

                // // If Goal Is Not == 'I'm playing the long game', skip NMN Question
                // var activeGoal = $('[data-action="goal"] .quiz-choice.active h3').html().trim();
                // if (
                //     activeGoal == 'I train and want more from it' ||
                //     activeGoal == 'I want to feel better, simply' ||
                //     activeGoal == 'I Want To Lose Fat & Tone Up' ||
                //     activeGoal == 'All of the above' 
                // ){

                //     hidePanel(panel);
                //     showPanel('nmn');

                // }else{
                //     hidePanel(panel);
                //     showPanel('current-supplement');
                // }


                hidePanel(panel);
                showPanel('nmn');

                

                

            break;
            
            case 'nmn':

            
                hidePanel(panel);
                // showPanel('current-supplement');

            
                var nmnOption = quizSelections.nmn;

                $('#unicorn-quiz-wrapper[data-active-panel="nmn.1"] [data-panel="nmn.1"]').removeClass('active');

                switch (nmnOption) {
                    
                    case 'not-interested':

                        if (preferredProduct == 'onefit'){
                            preferredProduct = 'onefit';
                        }
                        if (preferredProduct == 'onelife'){
                            preferredProduct = 'onefit';
                        }

                        // hidePanel('nmn');
                        // showPanel('current-supplement');

                        hidePanel('nmn');
                        showPanel('before-supplements');

                        setTimeout(() => {
                            $(`[data-panel="before-supplements"] .middle.fon-fade-blur`).addClass('fon-fade-blur-active');
                        },300);

                        setTimeout(() => {
                            $(`[data-panel="before-supplements"] .bottom.fon-fade-blur`).addClass('fon-fade-blur-active');
                        },2000);


                        
                    break;
                    
                    case 'yes':
                    case 'learn':
                    
                        showPanel('nmn.1');

                        setTimeout(() => {
                            $('.nmn-container').addClass('active');

                            setTimeout(() => {
                                $(`[data-panel="nmn.1"] .bottom.fon-fade-blur`).addClass('fon-fade-blur-active');
                            },2000);

                        },1000);

                        if (preferredProduct == 'onefit'){
                            preferredProduct = 'onelife';
                        }
                        $('#unicorn-quiz-wrapper').addClass('with-onelife');

                        // $('.unicorn-quiz-panel[data-panel="nmn.1').show();
                        // $('#unicorn-quiz-wrapper').attr('data-active-panel','nmn.1');


                        // $('#unicorn-quiz-wrapper').removeClass('with-onelife');
                        // setTimeout(function(){
                        //     $('#unicorn-quiz-wrapper[data-active-panel="nmn.1"] [data-panel="nmn.1"]').addClass('active');
                        // },300);
                    break;
                }

            break;

            case 'nmn.1':

                hidePanel(panel);
                showPanel('nmn.2');

                setTimeout(() => {
                    $('.nmn2-container').addClass('active');
                    setTimeout(() => {
                        $(`[data-panel="nmn.2"] .bottom.fon-fade-blur`).addClass('fon-fade-blur-active');
                    },2000);
                },1000);

                


                // if ($(this).data('action') == 'add-onelife'){
                //     $('#unicorn-quiz-wrapper').addClass('with-onelife');

                //     if (preferredProduct == 'onefit'){
                //         preferredProduct = 'comprehensive';
                //     }
                // }
                // if ($(this).data('action') == 'pass-onelife'){
                //     $('#unicorn-quiz-wrapper').removeClass('with-onelife');

                //      preferredProduct = 'onefit';
                // }


                // $('.unicorn-quiz-action-nmn').removeClass('d-none');
                // $('#unicorn-quiz-wrapper [data-panel="nmn.1"]').removeClass('active');

                // setTimeout(function(){
                //     hidePanel('nmn');
                //     hidePanel('nmn.1');
                //     showPanel('current-supplement');
                // },300);

            break;

            case 'nmn.2':
                hidePanel(panel);
                showPanel('before-supplements');

                setTimeout(() => {
                    $(`[data-panel="before-supplements"] .middle.fon-fade-blur`).addClass('fon-fade-blur-active');
                },300);

                setTimeout(() => {
                    $(`[data-panel="before-supplements"] .bottom.fon-fade-blur`).addClass('fon-fade-blur-active');
                },2000);

            break;
            case 'before-supplements':
                hidePanel(panel);
                showPanel('current-supplement');
            break;



            case 'current-supplement':



                var isOneLife = $('[data-action="current-supplement"]').attr('data-onelife');
                if (preferredProduct == 'onefit' && isOneLife == 'yes'){
                    preferredProduct = 'comprehensive';
                }

                if (preferredProduct == 'onefit' && isOneLife == 'no'){
                    preferredProduct = 'onefit';
                }

                if (preferredProduct == 'onelife' && isOneLife == 'yes'){
                    preferredProduct = 'onelife';
                }

                if (preferredProduct == 'onelife' && isOneLife == 'no'){
                    preferredProduct = 'comprehensive';
                }


                hidePanel(panel);
                showPanel('matter');

                // // Hide Matter Widgets
                // $('.unicorn-quiz-panel[data-panel="matter"] .unicorn-quiz-widget').hide();

          

                // var popup = preferredProduct;
                // var plan = '90d';

                // $(`.white-popup[data-popup="${popup}"]`).attr('data-plan',plan);
                // $('.popup-ingredients-container[data-popup="replace"]').addClass('active');
                // $('.popup-ingredients-container[data-popup="inside"]').removeClass('active');

                // $.magnificPopup.open({
                //     items: {
                //         src: `.white-popup[data-popup="${popup}"]`, 
                //         type: 'inline'
                //     },
                //     callbacks: {
                //         close: function() {
                //             resetCounters();
                //             animateCounters(preferredProduct);
                //         }
                //     }
                // });

            break;
            case 'matter':

                
                

                // preferredProduct = 'comprehensive';
                hidePanel(panel);
                showPanel('educational-' + preferredProduct);

                // alert(preferredProduct);
          

                var autoPlayOption = {
                    delay: 8500,
                    disableOnInteraction: false,
                    stopOnLastSlide: true,
                };

                if (preferredProduct == 'onefit'){
                    
                    $('.swiper-onefit-educational').parents('.unicorn-quiz-body').find('.bottom').hide();

                    swiperEducationOneFit = new Swiper('.swiper-onefit-educational', {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        loop: false,
                        effect: 'fade',
                        allowTouchMove: false,
                        fadeEffect: {
                            crossFade: true,
                        },
                         autoplay: false, //autoPlayOption,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                        on: {
                            slideChange: function () {
                                // if (this.isEnd) {
                                    
                                //     setTimeout(function(){
                                //         $('.swiper-onefit-educational').parents('.unicorn-quiz-body').find('.bottom').fadeIn();
                                //     },8000);
                                // }

                                const $wrapper = $('.swiper-onefit-educational');
                                const $activeSlide = $(this.slides[this.activeIndex]);

                                $wrapper.parents('.unicorn-quiz-body')
                                            .find('.bottom')
                                            .hide();

                                if (this.activeIndex >= 0){
                                    setTimeout(function(){
                                        $wrapper
                                            .parents('.unicorn-quiz-body')
                                            .find('.bottom')
                                            .fadeIn(600);
                                    },4000);
                                }
                            },
                        },
                    });

                    setTimeout(function(){
                        $('.swiper-onefit-educational').parents('.unicorn-quiz-body').find('.bottom').fadeIn(600);
                    },4000);

                }
                if (preferredProduct == 'onelife'){
                    
                    $('.swiper-onelife-educational').parents('.unicorn-quiz-body').find('.bottom').hide();

                    swiperEducationOneLife = new Swiper('.swiper-onelife-educational', {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        loop: false,
                        effect: 'fade',
                        allowTouchMove: false,
                        fadeEffect: {
                            crossFade: true,
                        },
                         autoplay: false, //autoPlayOption,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                        on: {
                            slideChange: function () {

                                

                                const $wrapper = $('.swiper-onelife-educational');
                                const $activeSlide = $(this.slides[this.activeIndex]);

                                $wrapper.parents('.unicorn-quiz-body')
                                            .find('.bottom')
                                            .hide();

                                if (this.activeIndex >= 0){

                                    var speed = 4000;

                                    // 2nd Slide
                                    // alert(this.activeIndex);
                                    if (this.activeIndex == 1){
                                        speed = 6500;
                                    }

                                    setTimeout(function(){
                                        $wrapper
                                            .parents('.unicorn-quiz-body')
                                            .find('.bottom')
                                            .fadeIn(600);
                                    },4000);
                                }

                                // if (this.isEnd) {
                                //     // $('.swiper-onelife-educational').parents('.unicorn-quiz-body').find('.bottom').fadeIn();
                                //      setTimeout(function(){
                                //         $('.swiper-onelife-educational').parents('.unicorn-quiz-body').find('.bottom').fadeIn();
                                //     },8000);
                                // }
                            },
                        },
                    });

                    setTimeout(function(){
                        $('.swiper-onelife-educational').parents('.unicorn-quiz-body').find('.bottom').fadeIn(600);
                    },4000);

                }
                if (preferredProduct == 'comprehensive'){
                    
                    $('.swiper-comprehensive-educational').parents('.unicorn-quiz-body').find('.bottom').hide();

                    swiperEducationComprehensive = new Swiper('.swiper-comprehensive-educational', {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        loop: false,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true,
                        },
                        allowTouchMove: false,
                        autoplay: false, //autoPlayOption,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                        on: {
                        slideChange: function () {

                            const $wrapper = $('.swiper-comprehensive-educational');
                            const $activeSlide = $(this.slides[this.activeIndex]);

                            $wrapper.parents('.unicorn-quiz-body')
                                        .find('.bottom')
                                        .hide();

                                    

                             $wrapper.removeClass('onefit-mode');

                            // onefit mode
                            if ($activeSlide.hasClass('swiper-slider-comprehensive-onefit')) {
                                $wrapper.addClass('onefit-mode');
                            }

                            // onelife mode
                            if ($activeSlide.hasClass('swiper-slider-comprehensive-onelife')) {
                                $wrapper.addClass('onelife-mode');
                            } else {
                                $wrapper.removeClass('onelife-mode');
                            }


                            // existing logic
                            if (this.activeIndex >= 0){
                                setTimeout(function(){
                                    $wrapper
                                        .parents('.unicorn-quiz-body')
                                        .find('.bottom')
                                        .fadeIn(600);
                                },4000);
                            }
                            
                            // existing logic
                            // if (this.isEnd) {
                            //     $wrapper
                            //         .parents('.unicorn-quiz-body')
                            //         .find('.bottom')
                            //         .fadeIn();
                            // }
                        },
                        },
                    });

                    setTimeout(function(){
                        $('.swiper-comprehensive-educational').parents('.unicorn-quiz-body').find('.bottom').fadeIn(600);
                    },4000);

                    // setTimeout(() => {
                    //     swiperEducationComprehensive.slideNext();
                    // },10000);


                }


                // // Show Popup
                // var popup = preferredProduct;
                // // showOutOfStockPopup(product);

               
                // var plan = '90d';

                // $(`.white-popup[data-popup="${popup}"]`).attr('data-plan',plan);
                // $('.popup-ingredients-container[data-popup="inside"]').addClass('active').show();
                // $('.popup-ingredients-container[data-popup="replace"]').removeClass('active');

                // $.magnificPopup.open({
                //     items: {
                //         src: `.white-popup[data-popup="${popup}"]`, 
                //         type: 'inline'
                //     },
                //     callbacks: {
                //         close: function() {
                //             resetCounters();
                //             animateCounters(preferredProduct);
                //         }
                //     }
                // });

                // //  $("#btn-quiz").trigger('click');
                // // hidePanel('start');
                // // showPanel('checkout');


                // $('.quiz-cart .product-buy-card').removeClass('super-active');
                // $('.quiz-cart .unicorn-buy-panel').removeClass('unica');

                // $('.quiz-cart [data-panel="'+popup+'"] [data-plan]').addClass('super-active');
                // $('.quiz-cart [data-panel="'+popup+'"]').addClass('unica');

                // $('.quiz-cart > div').show();
                // $('#quiz-product-buy-options [data-plan="90d"]').trigger('click');


                // // Aply Selection
                // quizSelections.status = 'completed';
                // applySelectionsToCart();
                


            break;

            case 'educational-comprehensive':


                if (!swiperEducationComprehensiveStatus){

                    swiperEducationComprehensive.slideNext();
                    if (swiperEducationComprehensive.activeIndex == 3){
                        swiperEducationComprehensiveStatus = true;
                    }

                }else{

                    var chosenProduct = panel.replace('educational-','');

                    hidePanel(panel);
                    showPanel('checkout');

                    $('.quiz-cart .product-buy-card').removeClass('super-active');
                    $('.quiz-cart .unicorn-buy-panel').removeClass('unica');

                    $('.quiz-cart [data-panel="'+chosenProduct+'"] [data-plan]').addClass('super-active animate-super-active-done');
                    $('.quiz-cart [data-panel="'+chosenProduct+'"]').addClass('unica');

                    $('.quiz-cart > div').show();
                    $('#quiz-product-buy-options [data-plan="90d"]').trigger('click');


                    animateCounters(chosenProduct);


                    // Aply Selection
                    quizSelections.status = 'completed';
                    applySelectionsToCart();


                    // Quiz Funnel New Cards
                    $('.flavour-options-wrapper').slideUp();
                    $('.quiz-cart-product-offers').removeClass('active');
                    $('.quiz-cart-' + chosenProduct).addClass('active');



                }
                

            break;

            case 'educational-onefit':  


                if (!swiperEducationOneFitStatus){

                    swiperEducationOneFit.slideNext();
                    if (swiperEducationOneFit.activeIndex == 2){
                        swiperEducationOneFitStatus = true;
                    }

                }else{
                    var chosenProduct = panel.replace('educational-','');

                    if (chosenProduct == 'onelife'){
                        $('.product-onefit-flavour-quiz').addClass('d-none');
                    }else{
                        $('.product-onelife-flavour-quiz').removeClass('d-none');
                    }

                    hidePanel(panel);
                    showPanel('checkout');

                    $('.quiz-cart .product-buy-card').removeClass('super-active');
                    $('.quiz-cart .unicorn-buy-panel').removeClass('unica');

                    $('.quiz-cart [data-panel="'+chosenProduct+'"] [data-plan]').addClass('super-active animate-super-active-done');
                    $('.quiz-cart [data-panel="'+chosenProduct+'"]').addClass('unica');

                    $('.quiz-cart > div').show();
                    $('#quiz-product-buy-options [data-plan="90d"]').trigger('click');


                    animateCounters(chosenProduct);


                    // Aply Selection
                    quizSelections.status = 'completed';
                    applySelectionsToCart();

                    // Quiz Funnel New Cards
                    $('.flavour-options-wrapper').slideUp();
                    $('.quiz-cart-product-offers').removeClass('active');
                    $('.quiz-cart-' + chosenProduct).addClass('active');
                }


            break;
            case 'educational-onelife':     


                if (!swiperEducationOneLifeStatus){


                    swiperEducationOneLife.slideNext();
                    if (swiperEducationOneLife.activeIndex == 2){
                        swiperEducationOneLifeStatus = true;
                    }

                }else{
                    var chosenProduct = panel.replace('educational-','');

                    if (chosenProduct == 'onelife'){
                        $('.product-onefit-flavour-quiz').addClass('d-none');
                    }else{
                        $('.product-onelife-flavour-quiz').removeClass('d-none');
                    }

                    hidePanel(panel);
                    showPanel('checkout');

                    $('.quiz-cart .product-buy-card').removeClass('super-active');
                    $('.quiz-cart .unicorn-buy-panel').removeClass('unica');

                    $('.quiz-cart [data-panel="'+chosenProduct+'"] [data-plan]').addClass('super-active animate-super-active-done');
                    $('.quiz-cart [data-panel="'+chosenProduct+'"]').addClass('unica');

                    $('.quiz-cart > div').show();
                    $('#quiz-product-buy-options [data-plan="90d"]').trigger('click');


                    animateCounters(chosenProduct);


                    // Aply Selection
                    quizSelections.status = 'completed';
                    applySelectionsToCart();

                    // Quiz Funnel New Cards
                    $('.flavour-options-wrapper').slideUp();
                    $('.quiz-cart-product-offers').removeClass('active');
                    $('.quiz-cart-' + chosenProduct).addClass('active');
                }

                // $('.animating').removeClass('animating');


            break;


            case 'checkout':

                hidePanel(panel);
                showPanel('checkout-final');
                $('body').removeClass('quiz-enabled');

                // 1. When transitioning INTO cart panel — push state
                history.pushState({ panel: 'quiz' }, '', '');
                
                

            break;
        }

        console.log('preferredProduct',preferredProduct);

    });

    // Back Panel
    $(document).on('click','.unicorn-quiz-heading .back',function(){


        const $parent = $('#unicorn-quiz-wrapper');

        $parent.find('mux-player').each(function () {
            this.pause();
            $(this).parent('.fon-video-lazy-container').removeClass('playing');
        });


        $('.swiper').removeClass('onefit-mode');

        const parent  = $(this).parents('.unicorn-quiz-panel')
        const panel = parent.data('panel');

        const prev_parent  = parent.prev();
        var prev_parent_panel = prev_parent.data('panel');


        if (panel == 'educational-onefit' ||
            panel == 'educational-onelife' || 
            panel == 'educational-comprehensive'
        ){
            prev_parent_panel = 'matter';
        }

        if (panel == 'checkout'){
            prev_parent_panel = 'matter';
            $('.unicorn-quiz-heading .close').trigger('click');
        }
        if (prev_parent_panel == 'after-goal-vsl'){
            $('[data-panel="after-goal-vsl"] .fon-video-play').trigger('click');
        }

        if (panel == 'current-supplement'){


                // If Goal Is Not == 'I'm playing the long game', skip NMN Question
                var activeGoal = $('[data-action="goal"] .quiz-choice.active h3').html().trim();
                if (
                    activeGoal == 'I train and want more from it' ||
                    activeGoal == 'I want to feel better, simply' ||
                    activeGoal == 'I Want To Lose Fat & Tone Up' ||
                    activeGoal == 'All of the above'
                ){
                    prev_parent_panel = 'nmn';

                }else{
                    prev_parent_panel = 'exercise';
                }

            
        }

        hidePanel(panel);
        showPanel(prev_parent_panel);

    });

    function hidePanel(panel){
        //  $('.unicorn-quiz-panel[data-panel="'+panel+'"').hide();

        $('.unicorn-quiz-panel[data-panel="'+panel+'"').addClass('animating-close');

        setTimeout(function(){
            $('.unicorn-quiz-panel[data-panel="'+panel+'"').hide().removeClass('animating-close');
        },800);
         
    }
    function showPanel(panel){

        $('.unicorn-quiz-panel[data-panel="'+panel+'"').show().addClass('animating-pre-open');
        setTimeout(function(){
            $('.unicorn-quiz-panel[data-panel="'+panel+'"').addClass('animating-open').removeClass('animating-pre-open');

            
        },800);

        setTimeout(function(){
            $('.unicorn-quiz-panel[data-panel="'+panel+'"').removeClass('animating-open');
        },1600);
        

        $('#unicorn-quiz-wrapper').attr('data-active-panel',panel);

        // $('.unicorn-quiz-panel[data-panel="'+panel+'"').fadeIn(1000);
        // $('#unicorn-quiz-wrapper').attr('data-active-panel',panel);


        // $('html, body').animate({
        //     scrollTop: $('.unicorn-buy-panel-quiz').offset().top - 100
        // }, 600); // 600ms smooth scroll


    }

    // $('.buy-options [data-product="comprehensive"]').trigger('click');


    
    $('.selected-flavour').html($('.flavour-options .swatch-container').first().addClass("selected").html());
    triggerOneFitChange();

    // flavour-dropdown
    

    $(document).on('click','.flavour button',function(){
        $('.product-onefit-flavour').addClass('active');
    });


    $(document).on('click','.swatch-container.available-flavour',function(){
        
        $('.flavour-options .swatch-container').removeClass('selected');
        $('.selected-flavour').html($(this).addClass("selected").html());
        $('.product-onefit-flavour').removeClass('active');

        var productSKU = $(this).find('.swatch').data('variant-sku');
        var productLabel = '';

        switch (productSKU){
            case 'OF-CH-BOX-700-V4.6':
                productLabel = '#1 rated Chocolate Milkshake';
            break;
            case 'OF-TC-BOX-700-V4.6':
                productLabel = 'Fruity & Refreshing ';
            break;
            case 'OF-VI-BOX-700-V4.6':
                productLabel = ' Smooth & Indulgent';
            break;
            case 'OF-FV-BOX-700-V4.6':
                productLabel = 'Rich & Creamy';
            break;
            case 'OF-CO-BOX-700-V4.6':
                productLabel = 'Rich & Chocolatey';
            break;
        }
        $('span.flavour-detail').html(productLabel);
        triggerOneFitChange();

    });

    function checkScroll() {
        var threshold = $('.section-unicorn-buy').parents('.shopify-section').offset().top + $('.shopify-section-group-header-group').outerHeight() - 100;

        if ($(window).scrollTop() > threshold) {
            $('.sticky-unicorn-selector').addClass('stick');
            // $('body').addClass('body-stick-unicorn-selector');
        } else {
            $('.sticky-unicorn-selector').removeClass('stick');
            // $('body').removeClass('body-stick-unicorn-selector');
        }
    }

    $(window).on('scroll load', checkScroll);


    // $(document).on('click','.unicorn-tabs-heading > div',function(){
    
    //     const tab = $(this).data('tab');
    //     $(this).addClass('active').siblings().removeClass('active');

    //     $(`.tab-content[data-tab="${tab}"]`).addClass('active').siblings().removeClass('active');


    // });
    $(document).on('click', '.unicorn-tabs-heading > div', function() {
        const tab = $(this).data('tab');
        $(this).addClass('active').siblings().removeClass('active');

        const $next = $(`.unicorn-tabs-content > div[data-tab="${tab}"]`);
        const $current = $('.unicorn-tabs-content > div.active');

        $current.css('opacity', 0);
        setTimeout(() => {
            $current.removeClass('active').css('opacity', '');
            $next.addClass('active').css('opacity', 0);
            requestAnimationFrame(() => $next.css('opacity', 1));
        }, 300);
    });


    // Clinical Range Compared "Get X" links: smooth-scroll up to the buy section,
    // then open that product's pathway by triggering its buy-options option (the
    // same click a shopper makes to pick a product). Product comes from the tab.
    $(document).on('click', '.unicorn-tabs-content .tab-link a', function (e) {
        e.preventDefault();
        var product = $(this).closest('[data-tab]').data('tab');   // onefit | onelife | comprehensive
        var $opt = $('.buy-options-main .option[data-product="' + product + '"]');
        if (!$opt.length || !$('#get-started').length) return;

        $('html, body').animate({
            scrollTop: $('#get-started').offset().top - 120
        }, 1300);

        // Open the pathway after the scroll settles.
        setTimeout(function () { $opt.trigger('click'); }, 500);
    });


    function triggerOneFitChange() {
        var selectedOneFitVariantSKU = $('.swatch-container.selected-flavour span').data('variant-sku');
        $('.plan-flavour-dropdown').each(function () {
            $(this)
                .val($(this).find('option[data-variant-sku="' + selectedOneFitVariantSKU + '"]').val())
                .trigger('change');
        });

        $('.available-flavour [data-variant-sku]').parent('.available-flavour').removeClass('d-none');
        $('.available-flavour [data-variant-sku="' + selectedOneFitVariantSKU + '"]').parent('.available-flavour').addClass('d-none');
    }

    // Checkout
    $(document).on('click','.btn-product-checkout',function(){
    
        const panel = $(this).parents('.unicorn-buy-panel');
        const productCard = panel.find('.product-buy-card.active');
        const plan = productCard.data('plan');
        


    });
    
    $(document).on('click','#btn-checkout-now',function(){
        
        var $btn = $(this);
        var originalText = $btn.text();
        $btn.text('Preparing your stack...').prop('disabled', true);

        // 1️⃣ Check cart first
        $.getJSON('/cart.js', function(cart) {
            const hasItems = cart.item_count > 0;

            // 2️⃣ Add to cart
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify(payload),
                dataType: 'json',
                contentType: 'application/json',
                success: function () {
                    // Straight to checkout with the bundle's free gifts — the cart
                    // drawer's CSS conflicts with unicorn's, so we skip it here.
                    // Failsafe: if we haven't navigated away, give the button back.
                    setTimeout(resetButton, 8000);
                    if (typeof FonCartDrawer !== "undefined" && FonCartDrawer.checkoutWithGifts) {
                        FonCartDrawer.checkoutWithGifts(resetButton);
                    } else {
                        window.location.href = '/checkout';
                    }
                },
                error: function () {
                    resetButton();
                    alert('Could not add item to cart. Please try again.');
                }
            });
        });

        function resetButton() {
            $btn.text(originalText).prop('disabled', false);
        }


    });


    $(document).on('input', '#input-name', function() {
        $('#btn-save-name').prop('disabled', $(this).val().trim() === '');
    });
        
    // // Quiz Choices
    // $(document).on('click','.unicorn-quiz-choices > div',function(){
        

    //     var outerParent = $(this).parents('.unicorn-quiz-choices');

    //     if (outerParent.hasClass('multiple')){

    //         $(this).toggleClass('active');

    //     }else{

    //         $(this).addClass('active').siblings().removeClass('active');

    //         var parent = $(this).parents('.unicorn-quiz-choices').siblings('.unicorn-quiz-action').find('button').prop('disabled',false);


    //         // If NMN
    //         if ($(this).parents('.unicorn-quiz-choices').data('action') == 'nmn'){
    //             var nmnOption = $('.unicorn-quiz-choices[data-action="nmn"] .active').data('value');

    //             hidePanel('nmn');
                

    //             switch (nmnOption){
    //                 case 'yes':
    //                     showPanel('current-supplement');
    //                     $('#unicorn-quiz-wrapper').addClass('with-onelife');
    //                 break;
    //                 case 'no':
    //                 case 'learn':
    //                     showPanel('nmn.1');
    //                     $('#unicorn-quiz-wrapper').removeClass('with-onelife');
    //                 break;
    //             }
    //         }

    //     }
        
    // });



    

    // ─── Name ─────────────────────────────────────────────────────────────────────
    $(document).on('input', '#input-name', function(){
        quizSelections.name = $(this).val().trim();
    });

    // ─── Quiz Choices ─────────────────────────────────────────────────────────────
    $(document).on('click', '.unicorn-quiz-choices[data-action="matter"] > div', function(){

        var choice = $(this).find('h3').html().trim();
        $('[data-type]').hide();
        $('[data-type="'+choice+'"]').fadeIn();


    });
    $(document).on('click', '.unicorn-quiz-choices > div', function(){

        var outerParent = $(this).parents('.unicorn-quiz-choices');
        var bodyParent = $(this).parents('.unicorn-quiz-body');
        var panelParent = $(this).parents('.unicorn-quiz-panel');

        outerParent.addClass('selected');
        
        var actionKey   = outerParent.data('action');

        if (outerParent.hasClass('multiple')) {


            const $clicked = $(this);
            const label = $clicked.find('h3').text().trim();

            $(this).toggleClass('active');

            // If "I'm New To Supplements" is clicked
            if (label === "I’m New To Supplements") {
                if ($clicked.hasClass('active')) {
                    // Remove all other selections
                    outerParent.find('.quiz-choice').not($clicked).removeClass('active');
                }
            } else {
                // If any OTHER item is clicked → disable "New To Supplements"
                outerParent.find('.quiz-choice').each(function () {
                    const text = $(this).find('h3').text().trim();
                    if (text === "I’m New To Supplements") {
                        $(this).removeClass('active');
                    }
                });
            }



            

            // Save as array (e.g. current-supplement)
            quizSelections[actionKey] = outerParent.find('.active').map(function(){
                return $(this).find('h3').text().trim();
            }).get();


            const targetSupplements = [
                "I’m New To Supplements",
                "NMN",
                "Electrolytes",
                "CoQ10",
                "Magnesium",
                "Ashwagandha",
                "L-Theanine",
                "Antioxidant"
            ];

            const hasTarget = quizSelections[actionKey].every(selected => {
                const value = selected.toLowerCase();

                return targetSupplements.some(target =>
                    value.includes(target.toLowerCase())
                );
            });

            console.log('Selected:', quizSelections[actionKey]);
            console.log('All selections valid:', hasTarget);

            if (hasTarget){
                $('[data-action="current-supplement"]').attr('data-onelife','yes');
            }else{
                $('[data-action="current-supplement"]').attr('data-onelife','no');
            }

            bodyParent.find('.unicorn-quiz-action').find('button').prop('disabled', false);


        } else {

            $(this).addClass('active').siblings().removeClass('active');

            bodyParent.find('.unicorn-quiz-action').find('button').prop('disabled', false);

            // Save value — prefer data-value attr, fall back to h3 text
            quizSelections[actionKey] = $(this).data('value') || $(this).find('h3').text().trim();


            // Goal
            if (actionKey == 'goal'){
                panelParent.find('.percent').html('30%');
                panelParent.find('.bar-inner').css('width','30%');
            }

            // NMN branching logic
            // if (actionKey === 'nmn') {
            //     var nmnOption = quizSelections.nmn;

                
            //     $('#unicorn-quiz-wrapper[data-active-panel="nmn.1"] [data-panel="nmn.1"]').removeClass('active');

            //     switch (nmnOption) {
            //         case 'yes':


            //             if (preferredProduct == 'onefit'){
            //                 preferredProduct = 'comprehensive';
            //             }


            //             hidePanel('nmn');
            //             showPanel('current-supplement');
            //             $('#unicorn-quiz-wrapper').addClass('with-onelife');
            //         break;
            //         case 'no':
            //         case 'learn':
            //             // showPanel('nmn.1');

            //              if ($(window).width() > 768){
            //                     hidePanel('nmn');
            //                 }

            //             $('.unicorn-quiz-panel[data-panel="nmn.1').show();
            //             $('#unicorn-quiz-wrapper').attr('data-active-panel','nmn.1');


            //             $('#unicorn-quiz-wrapper').removeClass('with-onelife');
            //             setTimeout(function(){
            //                 $('#unicorn-quiz-wrapper[data-active-panel="nmn.1"] [data-panel="nmn.1"]').addClass('active');

                           
                            
            //             },300);
            //         break;
            //     }
            // }
        }

        console.log('Quiz selections:', quizSelections);
    });

    // ─── OneLife decision (nmn.1 panel) ───────────────────────────────────────────
    $(document).on('click', '[data-action="add-onelife"]', function(){
        quizSelections.onelife_added = true;
    });

    $(document).on('click', '[data-action="pass-onelife"]', function(){
        quizSelections.onelife_added = false;
    });

    // ─── Apply to Cart & Checkout ─────────────────────────────────────────────────
    function applySelectionsToCart(callback) {
        var attributes = {
            'quiz_name':               quizSelections.name,
            'quiz_goal':               quizSelections.goal,
            'quiz_exercise':           quizSelections.exercise,
            'quiz_nmn':                quizSelections.nmn,
            'quiz_onelife_added':      quizSelections.onelife_added ? 'Yes' : 'No',
            'quiz_supplements':        quizSelections['current-supplement'].join(', '),
            'quiz_matters':            quizSelections.matter,
            'quiz_status':            quizSelections.status,
        };

        $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { attributes: attributes },
            dataType: 'json',
            success: function(cart) {
                console.log('Cart attributes saved:', cart.attributes);
                if (typeof callback === 'function') callback();
            },
            error: function(err) {
                console.error('Failed to update cart:', err);
                // Still proceed to checkout even if attributes fail
                if (typeof callback === 'function') callback();
            }
        });
    }

    // Quiz Choices
    $(document).on('click','#close-nmn-1',function(){
    
        
        
        $('.unicorn-quiz-action-nmn').removeClass('d-none');
        $('#unicorn-quiz-wrapper [data-panel="nmn.1"]').removeClass('active');

        setTimeout(function(){
            hidePanel('nmn.1');
            showPanel('nmn');
        },300);

    });


   

    // $(document).on('click','#quiz-product-buy-options .product-buy-plan > div',function(){

    //     var plan = $(this).data('plan');
     
    //     // $('.quiz-cart .product-buy-options .product-buy-plan > div[data-plan="'+plan+'"]').addClass('active').siblings().removeClass('active');
    //     // $('.quiz-cart .product-buy-cards .product-buy-card[data-plan="'+plan+'"]').addClass('active').siblings().removeClass('active');



    //      $('.quiz-cart .product-buy-options .product-buy-plan > div[data-plan="'+plan+'"]').addClass('active').fadeIn().siblings().removeClass('active').fadeOut();
    //     $('.quiz-cart .product-buy-cards .product-buy-card[data-plan="'+plan+'"]').addClass('active').fadeIn().siblings().removeClass('active').fadeOut();
        

    // });


    
    $(document).on('click','.quiz-cart .unicorn-buy-panel',function(){

        var panel = $(this);
        var product = panel.data('panel');

        nextReview();

        // if (product == 'onelife' || product == 'comprehensive'){
            
        //     showOutOfStockPopup(product);

        // }else{


            
            // $('.quiz-cart .product-buy-card').removeClass('super-active animate-super-active animate-super-active-done');

            var currentPanel = $(this);

            
            currentPanel.find('.product-buy-card.active').fadeOut().removeClass('active').siblings().fadeIn().addClass('active');
            
     

            // setTimeout(() => {


            //     currentPanel.find('.product-buy-card.active').addClass('animate-super-active-done');

            //     // if (product == 'onelife'){
            //     //     $('.product-onefit-flavour-quiz').hide();
            //     // }else{
            //     //     $('.product-onefit-flavour-quiz').show();
            //     // }
                

                
                
                
                
            //     setTimeout(() => {
            //         const $container = $('#unicorn-quiz-wrapper .unicorn-quiz-body');
            //         const $target = $('#quiz-product-buy-options');

            //         $container.animate({
            //             scrollTop: 100
            //         }, 800);

            //         currentPanel.addClass('unica').siblings().removeClass('unica');
            //         // animateCounters(currentPanel.data('panel'));

            //     }, 700);


            // },700);



           
        // }

    });

    var animated = false;

    function animateBars() {
        if (animated) return;
        animated = true;

        if ($(window).width() >= 768) {
            $('.bar-yellow').css('width', '30%'); // desktop
        } else {
            $('.bar-yellow').css('width', '60%'); // mobile
        }

        // setTimeout(function () {
            $('.bar-grey').css('width', '100%');
        // }, 1500);
    }

    var $section = $('.section-unicorn-math');

    if ('IntersectionObserver' in window) {

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    animateBars();
                    observer.disconnect();
                }
            });
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

        observer.observe($section[0]);

    } else {

        $(window).on('scroll.mathbars', function () {
            var top = $section[0].getBoundingClientRect().top;
            if (top < window.innerHeight - 50) {
                animateBars();
                $(window).off('scroll.mathbars');
            }
        }).trigger('scroll.mathbars');

    }


    function randomAdd(n) {
        return n + Math.floor(Math.random() * 4);
    }

    function animateCounters(product = 'onefit') {


        
        // alert(product);

        switch (product){
            case 'onefit':

                $('.stat-1').attr('data-number',randomAdd(41));
                $('.stat-2').attr('data-number',randomAdd(13));
                $('.stat-3').attr('data-number',randomAdd(15));
                $('.stat-4').attr('data-number',randomAdd(33));

            break;
            case 'onelife':

                $('.stat-1').attr('data-number',randomAdd(11));
                $('.stat-2').attr('data-number',randomAdd(46));
                $('.stat-3').attr('data-number',randomAdd(43));
                $('.stat-4').attr('data-number',randomAdd(17));

            break;
            case 'comprehensive':

                $('.stat-1').attr('data-number',randomAdd(49));
                $('.stat-2').attr('data-number',randomAdd(54));
                $('.stat-3').attr('data-number',randomAdd(51));
                $('.stat-4').attr('data-number',randomAdd(39));

            break;

        }

        setTimeout(() => {
            $('.checkout-ups .ups-item h3').each(function () {
                const $el = $(this);
                const target = parseInt($el.data('number'), 10);

                const duration = 2500; // slower animation (2s)
                const startTime = performance.now();

                function animate(currentTime) {
                    const elapsed = currentTime - startTime;
                    let progress = elapsed / duration;

                    // clamp to 1
                    progress = Math.min(progress, 1);

                    // easeOutCubic for smoother motion
                    const eased = 1 - Math.pow(1 - progress, 3);

                    const current = Math.round(target * eased);

                    $el.text('+' + current + '%');

                    if (progress < 1) {
                        requestAnimationFrame(animate);
                    }
                }

                $el.text('+0%');
                requestAnimationFrame(animate);
            });
        },1200);
    }

    function resetCounters() {
    $('.checkout-ups .ups-item h3').each(function() {
        $(this).text('+0%');
    });
    }




        var $track = $('.b2g1-ups');
        var $originals = $track.children().clone();
        var origW = 0;

        $track.children().each(function () {
            origW += $(this).outerWidth(true);
        });

        var clonesNeeded = Math.ceil($(window).width() / origW) + 1;

        for (var i = 0; i < clonesNeeded; i++) {
            $originals.clone().attr('aria-hidden', 'true').appendTo($track);
        }

        var offset = 0;
        var speed = 0.5;

        function animate() {
            offset += speed;
            if (offset >= origW) offset -= origW;
            $track.css('transform', 'translateX(-' + offset + 'px)');
            requestAnimationFrame(animate);
        }

        requestAnimationFrame(animate);
    


    function showOutOfStockPopup(variantID){
      $.magnificPopup.open({
        items: {
          src: '#klaviyo-oos-' + variantID // This is the ID of the hidden div
        },
        type: 'inline'
      });
    }
    
    
    

    // $(document).on('click','#show-oos',function(){
    //     showOutOfStockPopup('comprehensive');
    // });
    // $(document).on('click','#show-oos-onelife',function(){
    //     showOutOfStockPopup('onelife');
    // });

    $(document).on('click', 'a[href="#get-started-unicorn"].unicorn-get-started, [data-action="shop-unicorn"]', function() {

        $('.fon-mobile-close-image').trigger('click');
        $('html, body').animate({
            scrollTop: $('#get-started').offset().top - 100
        }, 800);
    });



   

    

    // close on backdrop click
    $('#upsell-overlay').on('click', function (e) {
        if ($(e.target).is('#upsell-overlay')) {
            $(this).removeClass('active');
            document.body.style.overflow = '';
        }
    });

    function closeUpsellPopup(){
        $('#upsell-overlay').removeClass('active');
        document.body.style.overflow = '';
    }

    $(document).on('click','.unicorn-upsell-popup-close',function(){
        closeUpsellPopup();
    });

    function openOnelifeUpsell(){
        $('#upsell-overlay').addClass('active').attr('active-product','onelife');
        document.body.style.overflow = 'hidden';
        $('.unicorn-upsell-popup [data-card]').hide();
        $('.unicorn-upsell-popup [data-card="onelife"]').show();

        $('.unicorn-upsell-popup .top p').html(`You’re getting OneFit. Add OneLife and unlock the longevity layer - NMN, Resveratrol, and cellular repair.`);
        $('.unicorn-upsell-popup .btn-continue-to-current').html(`No thanks, continue with OneFit Only`);
        
    }
    function openOnefitUpsell(){
        $('#upsell-overlay').addClass('active').attr('active-product','onelife');
        document.body.style.overflow = 'hidden';
        $('.unicorn-upsell-popup [data-card]').hide();
        $('.unicorn-upsell-popup [data-card="onefit"]').show();

        $('.unicorn-upsell-popup .top p').html(`You’re getting OneLife. Add OneFit and unlock the performance layer - Protein, creatine, magnesium, greens, collagen, probiotics, methylated vitamins and electrolytes.`);
        $('.unicorn-upsell-popup .btn-continue-to-current').html(`No thanks, continue with OneLife Only`);
    }

    $(document).on('click','.btn-upgrade-to-comprehensive',function(){

        
        if (isQuizUpsell){

            $('.buy-options-main .option').removeClass('active');
            var option = $('.buy-options-main .option[data-product="comprehensive"]').addClass('active');

            const product = option.data('product');

            option.siblings().removeClass('active');
            $('.pathway-popup"').removeClass('active');
            option.addClass('active');

            

            setTimeout(() => {

                
                $('.unicorn-buy-panel[data-panel="main"]').fadeOut(300).removeClass('active');

                $('.sticky-unicorn-selector').addClass('active');
                $(`.unicorn-buy-panel[data-panel="${product}"]`).fadeIn(300).addClass('active');

                $(`.unicorn-buy-panel[data-panel="${product}"] .product-buy-plan div`).first().trigger('click');

                $('body').addClass('body-stick-unicorn-selector');
                
            
                $(`.unicorn-buy-panel[data-panel="${product}"] .btn-product-checkout`).trigger('click');
                
                closeUpsellPopup();

                // $('html, body').animate({
                //     scrollTop: $('#get-started').offset().top - 120
                // }, 1300); // 600ms smooth scroll
                    

            }, 500);

        }else{

            
            
            $('.pathway-popup.active').removeClass('active');
            $('.pathway-popup[data-product="comprehensive"]').addClass('active');
            
            continuePathway();
            $('.pathway-popup.active').find('.continue-with-plan-wrapper').hide();
            $('.pathway-popup.active').find('.continue-with-checkout-before').show();


            $('.pathway-popup.active').find('.option-info-left .unicorn-quiz-widget').hide();
            $('.pathway-popup.active').find('.option-info-left .option-product-image').fadeIn();

        }

        

        
    });

    $(document).on('click','.btn-continue-to-current',function(){

        closeUpsellPopup();

        if (isQuizUpsell){

           

            var activeProduct = $('#upsell-overlay').attr('active-product');
            var panel = $('.unicorn-buy-product-panel.active');
            var product = panel.data('panel');
            processCheckout(panel);

            setTimeout(() => {
                $('.unicorn-buy-panel').not($('.unicorn-buy-panel[data-panel="cart"]')).fadeOut(600).removeClass('active');
                $('.unicorn-buy-panel[data-panel="cart"]').fadeIn(600,function(){
                    $('html, body').animate({
                        scrollTop: $('.section-unicorn-buy').offset().top - 100
                    }, 600); // 600ms smooth scroll
                }).addClass('active');

                $('.unicorn-buy-panel-cart').scrollTop(0);
                

            }, 500);

        }else{
            continuePathway();
        }


        
        
    });



    
    // $('.buy-options-main .option[data-product="onefit"]').trigger('click');
    function hidePathwayPanels(){
        $('.continue-with-plan-wrapper').fadeIn();
        $('.continue-with-checkout-before').hide();
        $('.continue-with-plan-continue-wrapper').hide(); 

        // $('html, body,.pathway-popup').animate({ scrollTop: 0 }, 600);
        $('html, body').css('scroll-behavior', 'auto');
            $(window).scrollTop($('#get-started').offset().top - 120);
    }

    $(document).on('click','.option-info .btn-continue-to-plan',function(){

        var parent = $(this).parents(".option-info");

        parent.find('.unicorn-quiz-widget').hide();
        parent.find('.option-product-image').fadeIn();

        parent.find('.continue-with-plan-wrapper').hide();
        parent.find('.continue-with-checkout-before').hide();
        parent.find('.continue-with-plan-continue-wrapper').fadeIn();
        

        $('.side-by-side-nav .text').html('<span class="fw-700">STEP 2:</span> PLAN');
        $('html, body,.pathway-popup').animate({ scrollTop: 0 }, 600);
        setPathwayProgressBar(80);


    });

    $(document).on('click','.selector-button',function(){

        $('.flavour-options-wrapper').slideToggle();

        if (!$('.flavour-options-wrapper .flavour-options > div.active').length){
            $('.flavour-options-wrapper .flavour-options > div').first().addClass('active');
        }
    });


    // Pre-select default
    // First Option Selected by default
    $('.plan-flavour-dropdown').each(function () {
        $(this).prop('selectedIndex', 0).trigger('change');
    });
    
    $(document).on('click','.flavour-options-wrapper .flavour-options > div',function(){

        var color = $(this).data('color');
        var flavourSKU = $(this).data('flavour-sku');
        var title = $(this).data('variant-title');
        var productLabel;


        switch (flavourSKU){
            case 'OF-CH-BOX-700-V4.6':
                productLabel = '#1 rated Chocolate Milkshake';
            break;
            case 'OF-TC-BOX-700-V4.6':
                productLabel = 'Fruity & Refreshing ';
            break;
            case 'OF-VI-BOX-700-V4.6':
                productLabel = ' Smooth & Indulgent';
            break;
            case 'OF-FV-BOX-700-V4.6':
                productLabel = 'Rich & Creamy';
            break;
            case 'OF-CO-BOX-700-V4.6':
                productLabel = 'Rich & Chocolatey';
            break;
        }

        $('.selector-swatch').css('background-color',color);
        $('.selector-text').html(title);
        $('.flavour-detail').html(productLabel);

        $('.flavour-options-wrapper').slideUp();

        // Change selected flavour
        $(this).addClass('active').siblings().removeClass('active');


        // var pathway = $(this).parents('.pathway-popup,.pathway-quiz-popup');
        var flavourClass = 'flavour-' + flavourSKU.replace(/\./g, '-');

        // pathway.find('.plan-flavour-dropdown').each(function () {
        $('.plan-flavour-dropdown').each(function () {
            var $dropdown = $(this);
            var $option = $dropdown.find('option.' + flavourClass);
            if ($option.length) {
                $dropdown.val($option.val()).trigger('change');
            }
        });
            

    });

    // Paying Options
    $(document).on('click','.paying-options > div',function(){
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    });
    


    // Pathway Progress Bar
    function setPathwayProgressBar(value){
        $('.option-progress-bar .option-progress').css('width',value + '%');

          // Pause all MUX 
        document.querySelectorAll('mux-player.fit-mux').forEach(p => p.pause());
    }

    // FAQs
    $('.product-info-list h3').on('click', function () {
        const $item = $(this).closest('.product-info-list');
        const isActive = $item.hasClass('active');
        $('.product-info-list').removeClass('active');
        if (!isActive) $item.addClass('active');
    });

    // Pathway Checkout
    $(document).on('click','.btn-continue-to-checkout',function(){

        
        // Quiz Funnel
        if ($(this).parents('.quiz-cart-product-offers').length){

            var quizProduct = $('.quiz-cart-product-offers.active').data('product');
            $('.btn-continue-to-final-checkout').trigger('click');

        }else{

            // Pathway Funnel

            var parent = $('.pathway-popup.active').find(".option-info");
            var pathway = $('.pathway-popup.active');
            var pathwayProduct = pathway.data('product');
            var pathwayPlanComponent = pathway.find('.fon-subscription-option.active');
            var pathwayPlan = pathway.find('.fon-subscription-option.active').data('payment-option');


            if (!$(this).hasClass('been-clicked')){
                $(this).addClass('been-clicked');
                openPathwayVSLOrCheckout();
            }else{
                
                continuePathway();
            }
            
        }


        // if (pathwayPlan == 'onetime'){

        //     if (pathwayProduct == 'onefit'){
        //         openOnefitUpsell();
        //     }
        //     if (pathwayProduct == 'onelife'){
        //         openOnelifeUpsell();
        //     }

        // }else{

            
            // if ($(window).width() <= 566){

            //     parent.find('.option-info-left .unicorn-quiz-widget').hide();
            //     parent.find('.option-info-right .unicorn-quiz-widget').show();

            //     parent.find('.continue-with-plan-continue-wrapper').hide();

            //     parent.find('.continue-with-checkout-before').fadeIn();
            //     parent.find('.option-product-image').fadeIn();

            //     setPathwayProgressBar(95);
            // }else{
            //     parent.find('.btn-continue-to-final-checkout').trigger('click');
            // }
            

        // }
        


       
    });

    function openPathwayVSLOrCheckout(){
       
      
        var parent = $('.pathway-popup.active').find(".option-info");
        var pathway = $('.pathway-popup.active');
        var pathwayProduct = pathway.data('product');
        var pathwayPlanComponent = pathway.find('.fon-subscription-option.active');
        var pathwayPlan = pathway.find('.fon-subscription-option.active').data('payment-option');

        
        if (pathwayPlan == 'onetime'){

            continuePathway();

        }else{


            if (pathwayProduct == 'onefit'){
                isQuizUpsell = false;
                openOnelifeUpsell();
            }else if (pathwayProduct == 'onelife'){
                isQuizUpsell = false;
                openOnefitUpsell();
            }else{
                continuePathway();
            }

        }
        

    }

    function continuePathway(){
        var parent = $('.pathway-popup.active').find(".option-info");
        var pathway = $('.pathway-popup.active');
        var pathwayProduct = pathway.data('product');
        var pathwayPlanComponent = pathway.find('.fon-subscription-option.active');
        var pathwayPlan = pathway.find('.fon-subscription-option.active').data('payment-option');

        closeUpsellPopup();
        
        if ($(window).width() <= 566){

            parent.find('.option-info-left .unicorn-quiz-widget').hide();
            parent.find('.option-info-right .unicorn-quiz-widget').show();

            parent.find('.continue-with-plan-continue-wrapper').hide();

            parent.find('.continue-with-checkout-before').fadeIn();
            parent.find('.option-product-image').fadeIn();

            setPathwayProgressBar(95);
            $('.side-by-side-nav .text').html('<span class="fw-700">STEP 3:</span> CHECKOUT');
            $('html, body,.pathway-popup').animate({ scrollTop: 0 }, 600);


        }else{
            parent.find('.btn-continue-to-final-checkout').trigger('click');
        }
    }


    function closePathwayFirstStep(){

        $('.buy-options-main > div').removeClass('active');
        $('.pathway-popup[data-product]').removeClass('active');
        $('body').removeClass('pathway-info-opened');
        hidePathwayPanels();


        setPathwayProgressBar(20);

        $('.side-by-side-nav .text').html('<span class="fw-700">STEP 1:</span> PRODUCT');
        // $('html, body,.pathway-popup').animate({ scrollTop: 0 }, 600);

        // Scroll to Get Started
        $('html, body').css('scroll-behavior', 'auto');
        $(window).scrollTop($('#get-started').offset().top - 120);

        $('.continue-with-plan-wrapper').removeAttr('data-parent-fade-out-animating');

        
        $('#unicorn-banner').next('.unicorn-quiz-widget').remove();
        $('#unicorn-banner').show();


        // Pathway to the top
        $('.pathway-popup').animate({ scrollTop: 0 }, 600);
        
    }
    $(document).on('click','.side-by-side-nav img',function(){




        var parent = $(this).parents('.option-info');


        if ($('.continue-with-plan-wrapper').is(':visible')) {

            closePathwayFirstStep();

            

        }
        if ($('.continue-with-plan-continue-wrapper').is(':visible')) {


            $('.pathway-popup.active .continue-with-plan-continue-wrapper').hide();
            $('.pathway-popup.active .continue-with-plan-wrapper').fadeIn();

            setPathwayProgressBar(20);


            $('.side-by-side-nav .text').html('<span class="fw-700">STEP 1:</span> PRODUCT');
            $('html, body, .pathway-popup').animate({ scrollTop: 0 }, 600);

                  parent.find('.unicorn-quiz-widget').fadeIn();
            parent.find('.option-product-image').hide();

        }


        if ($('.continue-with-checkout-before').is(':visible')) {

            
            $('.pathway-popup.active .continue-with-checkout-before').hide();
            $('.pathway-popup.active .continue-with-plan-continue-wrapper').fadeIn();

            setPathwayProgressBar(80);

            $('.side-by-side-nav .text').html('<span class="fw-700">STEP 2:</span> PRODUCT');
            $('html, body,.pathway-popup').animate({ scrollTop: 0 }, 600);

        }


        const $parent = $('#unicorn-quiz-wrapper');

        $parent.find('mux-player').each(function () {
            this.pause();
            $(this).parent('.fon-video-lazy-container').removeClass('playing');
        });


    });
 


    function ucdInit(config) {

        // Title & subtitle
        $('#ucd-drawer .ucd-header h1').text(config.title);
        $('#ucd-drawer .ucd-subtitle').text(config.subtitle).attr('href', config.subtitleUrl || '#');

        // Items
        const $items = $('#ucd-drawer .ucd-items').empty();
        $.each(config.items, function (i, item) {
            const badge = item.badge === 'check'
            ? '<span class="ucd-check"><img  width="25" src="https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Blue_Tick.png?v=1779764204"/></span>'
            : `<span class="ucd-badge">${item.badge}</span>`;

            $items.append(`
            <div class="ucd-item">
                <div class="ucd-item-img"><img src="${item.img}" alt="${item.name}"></div>
                <div class="ucd-item-info">
                <div class="ucd-item-name">${item.name}</div>
                <div class="ucd-item-sub">${item.sub}</div>
                </div>
                ${badge}
            </div>
            `);
        });

        // Summary rows
        const $summary = $('#ucd-drawer .ucd-summary').empty();
        $.each(config.summary, function (i, row) {
            $summary.append(`
            <div class="ucd-summary-row">
                <span>${row.label}</span>
                <span>${row.value}</span>
            </div>
            `);
        });

        // Total & button
        $('#ucd-drawer .ucd-total-amount').text(config.total);
        $('#ucd-drawer .ucd-btn').text(config.btnText);

        }


    function ucdOpen() {
        $('#ucd-drawer, #ucd-overlay').addClass('open');
        $('body').css('overflow', 'hidden');
    }

    function ucdClose() {
        $('#ucd-drawer, #ucd-overlay').removeClass('open');
        $('body').css('overflow', '');
    }

    

    // Trigger — attach to any button you want
    $('#your-cart-trigger-btn').on('click', function () {
        ucdOpen();
    });

    // Close on overlay click
    $('#ucd-overlay').on('click', function () {
        ucdClose();
    });

    $(document).on('click', '.ucd-close-btn', function () {


        ucdClose();

        // Check if pathway
        if ($('.pathway-info-opened').length && $(window).width() <= 768){
            closePathwayFirstStep();
             $('.pathway-popup').animate({ scrollTop: 0 }, 600);
        }

    });


    // Pathway Final Checkout

    var pathwayPayload;

    $(document).on('click','.btn-continue-to-final-checkout',function(){

        
        var pathway = $('.pathway-popup.active');

 

        // Quiz Pathway Active
        if ($('.quiz-cart-product-offers.active').length){
            pathway = $('.quiz-cart-product-offers.active');
        }


        if (pathway.length){

                   


            
            var pathwayProduct = pathway.data('product');
            var pathwayPlanComponent = pathway.find('.fon-subscription-option.active');
            var pathwayPlan = pathway.find('.fon-subscription-option.active').data('payment-option');

            var pathwayForm = pathway.find('.fon-subscription-option.active .pathway-buy-form');

            console.log('pathwayProduct',pathwayProduct);
            console.log('pathwayPlan',pathwayPlan);

        

            switch (pathwayProduct){
                case 'onefit':

                    switch (pathwayPlan){
                        case 'subscription-90d':

                            var perDay = pathwayPlanComponent.data('per-day');
                            var billedAmount = pathwayPlanComponent.data('billed');
                            
                            var formOneFit = pathwayForm.find('[name="pathway-onefit-90d-product"]');
                            var formOneFitVariantID = formOneFit.val();
                            var formOneFitSellingPlanID = formOneFit.find('option:selected').data('selling-plan-id');
                            var formOneFitFlavour = formOneFit.find('option:selected').text().trim();
                            var formOneFitSKU = formOneFit.find('option:selected').data('variant-sku')

                            var formOneFitQty = formOneFit.data('qty');

                            var formBottle = pathwayForm.find('[name="pathway-onefit-90d-bottle"]');
                            var formBottleVariantID = formBottle.val();
                            var formBottleQty = formBottle.data('qty');

                            var formFrother = pathwayForm.find('[name="pathway-onefit-90d-frother"]');
                            var formFrotherVariantID = formFrother.val();
                            var formFrotherQty = formFrother.data('qty');

                            var formData = {
                                items: [
                                    {
                                    id: formOneFitVariantID,
                                    quantity: formOneFitQty,
                                    selling_plan: formOneFitSellingPlanID,
                                    properties : {
                                        '_BUNDLE' : 'onefit_90d',
                                        '_bundle_group_id' : 'onefit_90d_' + formOneFitVariantID,
                                        "_bundle_group_product" : true,
                                        "_bundle_group_product_row" : 1,
                                        '_offer' : 'onefit_90d_' + formOneFitVariantID,
                                        '_offer_product_type' : 'primary',
                                        '_order_from' : 'pathway_onefit-' + orderFromValue
                                    }
                                    }
                                ]
                            };


                            if (false && !bottleOOS) /*free gift off*/ {
                                formData.items.push({
                                    id: formBottleVariantID, // Free bottle variant ID
                                    quantity: formBottleQty,
                                    properties : {
                                        '_offer' : 'onefit_90d_' + formOneFitVariantID,
                                        '_offer_product_type' : 'free',
                                    }
                                });
                            }

                            if (false && !frotherOOS) /*free gift off*/ {
                                formData.items.push({
                                    id: formFrotherVariantID, // Free frother variant ID
                                    quantity: formFrotherQty,
                                    properties : {
                                        '_offer' : 'onefit_90d_' + formOneFitVariantID,
                                        '_offer_product_type' : 'free',
                                    }
                                });
                            }
                            pathwayPayload = formData;

                            console.log('pathwayPayload',pathwayPayload);


                            

                            ucdInit({
                                title: 'Complete Your Order',
                                subtitle: 'See How Complete System Fits Into Your Day',
                                subtitleUrl: '#',
                                items: [
                                    { img: thumbnailBySKU(formOneFitSKU), name: 'OneFit (90 Sachets)', sub: formOneFitFlavour, badge: 'check' },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562',                        name: 'OneLife (90 Sachets)', sub: 'Watermelon',          badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925', name: 'FON Drink Bottle',  sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925',                           name: 'FON Premium Mixer',    sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                ],
                                summary: [
                                    { label: 'Supply',      value: '90 Daily Serves of OneFit' },
                                    { label: 'Daily Price', value: perDay + ' per day' },
                                    { label: 'Shipping',    value: 'Priority Included' },
                                ],
                                total: billedAmount,
                                btnText: 'Checkout',
                            });

                            ucdOpen();


                        break;
                        case 'onetime':


                            var perDay = pathwayPlanComponent.data('per-day');
                            var billedAmount = pathwayPlanComponent.data('billed');
                            
                            var formOneFit = pathwayForm.find('[name="pathway-onefit-30d-product"]');
                            var formOneFitVariantID = formOneFit.val();
                            var formOneFitFlavour = formOneFit.find('option:selected').text().trim();
                            var formOneFitSKU = formOneFit.find('option:selected').data('variant-sku')

                            var formOneFitQty = formOneFit.data('qty');


                            var formData = {
                                items: [
                                    {
                                        id: formOneFitVariantID,
                                        quantity: formOneFitQty,
                                        properties : {
                                            '_order_from' : 'pathway_onefit-' + orderFromValue
                                        }
                                    }
                                ]
                            };
                            pathwayPayload = formData;

                            console.log('pathwayPayload',pathwayPayload);

                            ucdInit({
                                title: 'Complete Your Order',
                                subtitle: 'See How Complete System Fits Into Your Day',
                                subtitleUrl: '#',
                                items: [
                                    { img: thumbnailBySKU(formOneFitSKU), name: 'OneFit', sub: formOneFitFlavour, badge: 'check' },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562',                        name: 'OneLife (90 Sachets)', sub: 'Watermelon',          badge: 'check' },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925', name: 'FON Drink Bottle',  sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925',                           name: 'FON Premium Mixer',    sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                ],
                                summary: [
                                    { label: 'Supply',      value: '20 Daily Serves of OneFit' },
                                    { label: 'Daily Price', value: perDay + ' per serve' },
                                    { label: 'Shipping',    value: 'Priority Included' },
                                ],
                                total: billedAmount,
                                btnText: 'Checkout',
                            });

                            ucdOpen();

                        break;
                    }


                break;


                case 'onelife':

                    switch (pathwayPlan){
                        case 'subscription-90d':

                            var perDay = pathwayPlanComponent.data('per-day');
                            var billedAmount = pathwayPlanComponent.data('billed');
                            
                            var formOneLife = pathwayForm.find('[name="pathway-onelife-90d-product"]');
                            var formOneLifeVariantID = formOneLife.find('option:first').val();

                            var formOneLifeSellingPlanID = formOneLife.find('option:first').data('selling-plan-id');

                            var formOneLifeSKU = formOneLife.find('option:selected').data('variant-sku')

                            var formOneLifeQty = formOneLife.data('qty');

                            var formBottle = pathwayForm.find('[name="pathway-onelife-90d-bottle"]');
                            var formBottleVariantID = formBottle.val();
                            var formBottleQty = formBottle.data('qty');

                            var formFrother = pathwayForm.find('[name="pathway-onelife-90d-frother"]');
                            var formFrotherVariantID = formFrother.val();
                            var formFrotherQty = formFrother.data('qty');

                            var formData = {
                                items: [
                                    {
                                    id: formOneLifeVariantID,
                                    quantity: formOneLifeQty,
                                    selling_plan: formOneLifeSellingPlanID,
                                    properties : {
                                        '_BUNDLE' : 'onelife_90d',
                                        '_bundle_group_id' : 'onelife_90d_' + formOneLifeSellingPlanID,
                                        "_bundle_group_product" : true,
                                        "_bundle_group_product_row" : 1,
                                        '_offer' : 'onelife_90d_' + formOneLifeSellingPlanID,
                                        '_offer_product_type' : 'primary',
                                        '_order_from' : 'pathway_onelife-' + orderFromValue
                                    }
                                    }
                                ]
                            };


                            if (false && !bottleOOS) /*free gift off*/ {
                                formData.items.push({
                                    id: formBottleVariantID, // Free bottle variant ID
                                    quantity: formBottleQty,
                                    properties : {
                                        '_offer' : 'onelife_90d_' + formOneLifeSellingPlanID,
                                        '_offer_product_type' : 'free',
                                    }
                                });
                            }

                            if (false && !frotherOOS) /*free gift off*/ {
                                formData.items.push({
                                    id: formFrotherVariantID, // Free frother variant ID
                                    quantity: formFrotherQty,
                                    properties : {
                                        '_offer' : 'onelife_90d_' + formOneLifeSellingPlanID,
                                        '_offer_product_type' : 'free',
                                    }
                                });
                            }
                            pathwayPayload = formData;

                            console.log('pathwayPayload',pathwayPayload);


                            

                            ucdInit({
                                title: 'Complete Your Order',
                                subtitle: 'See How Complete System Fits Into Your Day',
                                subtitleUrl: '#',
                                items: [
                                    // { img: thumbnailBySKU(formOneFitSKU), name: 'OneFit (90 Sachets)', sub: formOneFitFlavour, badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562',                        name: 'OneLife (90 Serves)', sub: 'Watermelon',          badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925', name: 'FON Drink Bottle',  sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925',                           name: 'FON Premium Mixer',    sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                ],
                                summary: [
                                    { label: 'Supply',      value: '90 Daily Serves of OneLife' },
                                    { label: 'Daily Price', value: perDay + ' per day' },
                                    { label: 'Shipping',    value: 'Priority Included' },
                                ],
                                total: billedAmount,
                                btnText: 'Checkout',
                            });

                            ucdOpen();


                        break;
                        case 'onetime':


                            var perDay = pathwayPlanComponent.data('per-day');
                            var billedAmount = pathwayPlanComponent.data('billed');
                            
                            var formOneLife = pathwayForm.find('[name="pathway-onelife-30d-product"]');
                            var formOneLifeVariantID = formOneLife.find('option:first').val();

                            var formOneLifeQty = formOneLife.data('qty');


                            var formData = {
                                items: [
                                    {
                                        id: formOneLifeVariantID,
                                        quantity: formOneFitQty,
                                        properties : {
                                            '_order_from' : 'pathway_onelife-' + orderFromValue
                                        }
                                    }
                                ]
                            };
                            pathwayPayload = formData;

                            console.log('pathwayPayload',pathwayPayload);

                            ucdInit({
                                title: 'Complete Your Order',
                                subtitle: 'See How Complete System Fits Into Your Day',
                                subtitleUrl: '#',
                                items: [
                                    // { img: thumbnailBySKU(formOneFitSKU), name: 'OneFit', sub: formOneFitFlavour, badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562',                        name: 'OneLife (30 Serves)', sub: 'Watermelon',          badge: 'check' },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925', name: 'FON Drink Bottle',  sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925',                           name: 'FON Premium Mixer',    sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                ],
                                summary: [
                                    { label: 'Supply',      value: '30 Daily Serves of OneLife' },
                                    { label: 'Daily Price', value: perDay + ' per serve' },
                                    { label: 'Shipping',    value: 'Priority Included' },
                                ],
                                total: billedAmount,
                                btnText: 'Checkout',
                            });

                            ucdOpen();

                        break;
                    }


                break;


                case 'comprehensive':

                    switch (pathwayPlan){
                        case 'subscription-90d':

                            var perDay = pathwayPlanComponent.data('per-day');
                            var billedAmount = pathwayPlanComponent.data('billed');
                            
                            var formComprehensive = pathwayForm.find('[name="pathway-comprehensive-90d-onefit"]');
                            var formComprehensiveVariantID = formComprehensive.val();
                            var formComprehensiveSellingPlanID = formComprehensive.find('option:selected').data('selling-plan-id');
                            var formComprehensiveFlavour = formComprehensive.find('option:selected').text().trim();
                            var formComprehensiveSKU = formComprehensive.find('option:selected').data('variant-sku');
                            var formComprehensiveQty = formComprehensive.data('qty');


                            var formComprehensiveOneLife = pathwayForm.find('[name="pathway-comprehensive-90d-onelife"]');
                            var formComprehensiveOneLifeVariantID = formComprehensiveOneLife.val();
                            // var formComprehensiveOneLifeSellingPlanID = formComprehensiveOneLife.find('option:first').data('selling-plan-id');

                            var formComprehensiveOneLifeSellingPlanID = formComprehensiveOneLife.data('selling-plan-id');
                            var formComprehensiveOneLifeSKU = formComprehensiveOneLife.data('variant-sku');
                            var formComprehensiveOneLifeQty = formComprehensiveOneLife.data('qty');
                            

                            var formBottle = pathwayForm.find('[name="pathway-comprehensive-90d-bottle"]');
                            var formBottleVariantID = formBottle.val();
                            var formBottleQty = formBottle.data('qty');

                            var formFrother = pathwayForm.find('[name="pathway-comprehensive-90d-frother"]');
                            var formFrotherVariantID = formFrother.val();
                            var formFrotherQty = formFrother.data('qty');

                            var formData = {
                                items: [
                                    {
                                    id: formComprehensiveVariantID,
                                    quantity: formComprehensiveQty,
                                    selling_plan: formComprehensiveSellingPlanID,
                                    properties : {
                                        '_BUNDLE' : 'comprehensive_90d',
                                        '_bundle_group_id' : 'comprehensive_90d_' + formComprehensiveVariantID,
                                        "_bundle_group_product" : true,
                                        "_bundle_group_product_row" : 1,
                                        "_bundle_group_product_multiplier" : formComprehensiveQty,
                                        '_offer' : 'comprehensive_90d_' + formComprehensiveVariantID,
                                        '_offer_product_type' : 'primary',
                                        '_order_from' : 'pathway_comprehensive-' + orderFromValue
                                    }
                                    }
                                ]
                            };


                            formData.items.push({
                                id: formComprehensiveOneLifeVariantID,
                                quantity: formComprehensiveOneLifeQty,
                                selling_plan: formComprehensiveOneLifeSellingPlanID,
                                properties : {
                                    '_BUNDLE' : 'comprehensive_90d',
                                    '_bundle_group_id' : 'comprehensive_90d_' + formComprehensiveVariantID,
                                    "_bundle_group_product" : true,
                                    "_bundle_group_product_row" : 2,
                                    "_bundle_group_product_multiplier" : formComprehensiveOneLifeQty,
                                    '_offer' : 'comprehensive_90d_' + formComprehensiveVariantID,
                                    '_offer_product_type' : 'primary',
                                    '_order_from' : 'pathway_comprehensive-' + orderFromValue
                                }
                            });


                            if (false && !bottleOOS) /*free gift off*/ {
                                formData.items.push({
                                    id: formBottleVariantID, // Free bottle variant ID
                                    quantity: formBottleQty,
                                    properties : {
                                        '_offer' : 'onefit_90d_' + formComprehensiveVariantID,
                                        '_offer_product_type' : 'free',
                                    }
                                });
                            }

                            if (false && !frotherOOS) /*free gift off*/ {
                                formData.items.push({
                                    id: formFrotherVariantID, // Free frother variant ID
                                    quantity: formFrotherQty,
                                    properties : {
                                        '_offer' : 'onefit_90d_' + formComprehensiveVariantID,
                                        '_offer_product_type' : 'free',
                                    }
                                });
                            }
                            pathwayPayload = formData;

                            console.log('pathwayPayload',pathwayPayload);


                            

                            ucdInit({
                                title: 'Complete Your Order',
                                subtitle: 'See How Complete System Fits Into Your Day',
                                subtitleUrl: '#',
                                items: [
                                    { img: thumbnailBySKU(formComprehensiveSKU), name: 'OneFit (90 Sachets)', sub: formComprehensiveFlavour, badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562',                        name: 'OneLife (90 Serves)', sub: 'Watermelon',          badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925', name: 'FON Drink Bottle',  sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925',                           name: 'FON Premium Mixer',    sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                ],
                                summary: [
                                    { label: 'Supply',      value: '90 Daily Serves of OneFit & OneLife' },
                                    { label: 'Daily Price', value: perDay + ' per day' },
                                    { label: 'Shipping',    value: 'Priority Included' },
                                ],
                                total: billedAmount,
                                btnText: 'Checkout',
                            });

                            ucdOpen();


                        break;
                        case 'onetime':

                            var perDay = pathwayPlanComponent.data('per-day');
                            var billedAmount = pathwayPlanComponent.data('billed');

                            var formComprehensive = pathwayForm.find('[name="pathway-comprehensive-30d-onefit"]');
                            var formComprehensiveVariantID = formComprehensive.val();
                            var formComprehensiveSellingPlanID = formComprehensive.find('option:selected').data('selling-plan-id');
                            var formComprehensiveFlavour = formComprehensive.find('option:selected').text().trim();
                            var formComprehensiveSKU = formComprehensive.find('option:selected').data('variant-sku');
                            var formComprehensiveQty = formComprehensive.data('qty');


                            var formComprehensiveOneLife = pathwayForm.find('[name="pathway-comprehensive-30d-onelife"]');
                            var formComprehensiveOneLifeVariantID = formComprehensiveOneLife.val();
                            var formComprehensiveOneLifeSellingPlanID = formComprehensiveOneLife.find('option:first').data('selling-plan-id');
                            var formComprehensiveOneLifeSKU = formComprehensiveOneLife.find('option:first').data('variant-sku')
                            var formComprehensiveOneLifeQty = formComprehensiveOneLife.data('qty');


                            // var formBottle = pathwayForm.find('[name="pathway-comprehensive-30d-bottle"]');
                            // var formBottleVariantID = formBottle.val();
                            // var formBottleQty = formBottle.data('qty');

                            // var formFrother = pathwayForm.find('[name="pathway-comprehensive-30d-frother"]');
                            // var formFrotherVariantID = formFrother.val();
                            // var formFrotherQty = formFrother.data('qty');

                            var formData = {
                                items: [
                                    {
                                    id: formComprehensiveVariantID,
                                    quantity: formComprehensiveQty,
                                    // selling_plan: formComprehensiveSellingPlanID,
                                    properties : {
                                        '_BUNDLE' : 'comprehensive_30d',
                                        '_bundle_group_id' : 'comprehensive_30d_' + formComprehensiveVariantID,
                                        "_bundle_group_product" : true,
                                        "_bundle_group_product_row" : 1,
                                        "_bundle_group_product_multiplier" : formComprehensiveQty,
                                        '_offer' : 'comprehensive_30d_' + formComprehensiveVariantID,
                                        '_offer_product_type' : 'primary',
                                        '_order_from' : 'pathway_comprehensive-' + orderFromValue
                                    }
                                    }
                                ]
                            };


                            formData.items.push({
                                id: formComprehensiveOneLifeVariantID,
                                quantity: formComprehensiveOneLifeQty,
                                // selling_plan: formComprehensiveOneLifeSellingPlanID,
                                properties : {
                                    '_BUNDLE' : 'comprehensive_30d',
                                    '_bundle_group_id' : 'comprehensive_30d_' + formComprehensiveVariantID,
                                    "_bundle_group_product" : true,
                                    "_bundle_group_product_row" : 2,
                                    "_bundle_group_product_multiplier" : formComprehensiveOneLifeQty,
                                    '_offer' : 'comprehensive_30d_' + formComprehensiveVariantID,
                                    '_offer_product_type' : 'primary',
                                    '_order_from' : 'pathway_comprehensive-' + orderFromValue
                                }
                            });


                            // if (false && !bottleOOS) /*free gift off*/ {
                            //     formData.items.push({
                            //         id: formBottleVariantID, // Free bottle variant ID
                            //         quantity: formBottleQty,
                            //         properties : {
                            //             '_offer' : 'onefit_90d_' + formComprehensiveVariantID,
                            //             '_offer_product_type' : 'free',
                            //         }
                            //     });
                            // }

                            // if (false && !frotherOOS) /*free gift off*/ {
                            //     formData.items.push({
                            //         id: formFrotherVariantID, // Free frother variant ID
                            //         quantity: formFrotherQty,
                            //         properties : {
                            //             '_offer' : 'onefit_90d_' + formComprehensiveVariantID,
                            //             '_offer_product_type' : 'free',
                            //         }
                            //     });
                            // }
                            pathwayPayload = formData;

                            console.log('pathwayPayload',pathwayPayload);




                            ucdInit({
                                title: 'Complete Your Order',
                                subtitle: 'See How Complete System Fits Into Your Day',
                                subtitleUrl: '#',
                                items: [
                                    { img: thumbnailBySKU(formComprehensiveSKU), name: 'OneFit (30 Sachets)', sub: formComprehensiveFlavour, badge: 'check' },
                                    { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife-Jar_Single0Shot_6.png?v=1781839562',                        name: 'OneLife (30 Serves)', sub: 'Watermelon',          badge: 'check' },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/FON_Clear-Bottle_100x100_crop_center-removebg-preview.png?v=1779762925', name: 'FON Drink Bottle',  sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                    // { img: 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_Cart_Frother.png?v=1776989925',                           name: 'FON Premium Mixer',    sub: 'VIP Welcome Kit',    badge: 'FREE'  },
                                ],
                                summary: [
                                    { label: 'Supply',      value: '30 Daily Serves of OneFit & OneLife' },
                                    { label: 'Daily Price', value: perDay + ' per day' },
                                    { label: 'Shipping',    value: 'Priority Included' },
                                ],
                                total: billedAmount,
                                btnText: 'Checkout',
                            });

                            ucdOpen();


                            

                        break;
                    }


                break;
            }
        }else{
            alert('Note: There is no product selected');
        }



    });


    // Pathway Checkout
    $(document).on('click', '.ucd-btn', function () {

        var $btn = $(this);
        var originalText = $btn.text();
        $btn.text('Preparing your stack...').prop('disabled', true);

        function resetButton() {
            $btn.text(originalText).prop('disabled', false);
        }

        // 1️⃣ Clear cart first
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function () {

                // 2️⃣ Add to cart
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: JSON.stringify(pathwayPayload),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function () {
                        // Cart was cleared and the pathway bundle added — go straight
                        // to checkout with its free gifts, bypassing the drawer.
                        // Failsafe: if we haven't navigated away, give the button back.
                        setTimeout(resetButton, 8000);
                        if (typeof FonCartDrawer !== 'undefined' && FonCartDrawer.checkoutWithGifts) {
                            FonCartDrawer.checkoutWithGifts(resetButton);
                        } else {
                            window.location.href = '/checkout';
                        }
                    },
                    error: function () {
                        resetButton();
                        alert('Could not add item to cart. Please try again.');
                    }
                });

            },
            error: function () {
                resetButton();
                alert('Could not clear cart. Please try again.');
            }
        });

    });

    function thumbnailBySKU(sku){

        var thumbnailURL;

        switch (sku){
            case 'OF-CH-BOX-700-V4.6':
                thumbnailURL = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Choc_Milkshake_box_1500x1500-removebg-preview.png?v=1777851476';
            break;
            case 'OF-TC-BOX-700-V4.6':
                thumbnailURL = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_TC.png?v=1777851907';
            break;
            case 'OF-VI-BOX-700-V4.6':
                thumbnailURL = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_FV.png?v=1777851907';
            break;
            case 'OF-CO-BOX-700-V4.6':
                thumbnailURL = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_Plant_Vanilla.png?v=1777851907';
            break;
            case 'OF-FV-BOX-700-V4.6':
                thumbnailURL = 'https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Unicorn_OneFit_Plant_Cacao.png?v=1777851907';
            break;
        }

        return thumbnailURL;
    }

    $(document).on('click','.bar-wrapper .logo',function(){
        window.location.href= 'https://usefon.com';
    });
    
    


})